function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#66CEEF;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M494.2,693.6C493.85,693.42,493.85,693.42,494.2,693.6l-8.24-4.73c-28.58,23.49-49.61,61.71-53.65,98.7 l18.23,10.52c0.18-0.88,0.35-1.58,0.53-2.45c0.53-3.33,1.23-6.84,2.1-10.17c0.53-2.45,1.23-4.91,1.93-7.36 c0.7-2.45,1.58-4.91,2.45-7.54c1.23-3.86,2.81-7.54,4.38-11.22c0.53-1.23,1.05-2.28,1.58-3.33c2.28-4.91,4.73-9.82,7.36-14.55 c0.18-0.18,0.18-0.35,0.35-0.53c0.18-0.18,0.18-0.35,0.35-0.53c2.98-5.26,6.31-10.34,9.99-15.25c0.7-0.88,1.23-1.75,1.93-2.63 c2.63-3.51,5.43-6.66,8.24-9.99c1.75-1.93,3.33-4.03,5.26-5.79c1.05-1.05,2.28-2.1,3.33-3.16c2.45-2.28,4.73-4.56,7.19-6.66 C502.44,696.93,498.06,695.7,494.2,693.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M449.32,808.43c0-1.05,0.35-2.1,0.35-3.16l-24.37-14.03c2.98-39.1,24.02-79.77,54.52-105.72l-5.79-3.33 c-30.68,26.82-52.07,67.85-55.22,108.52c-0.18,2.45,1.05,4.91,3.16,6.14l30.5,17.53c1.05,0.53,2.1,0.88,3.33,0.88 c-1.23,0-2.45-0.35-3.51-1.05C450.37,812.99,449.32,810.71,449.32,808.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M458.79,814.39C458.79,814.39,458.79,814.21,458.79,814.39c-0.88,0.35-1.93,0.7-2.98,0.7 C456.86,815.09,457.73,815.09,458.79,814.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M559.59,675.01c7.54,0.18,14.9,1.58,21.21,5.26c-2.63-1.58-5.79-3.33-8.94-5.26 c-4.91-2.98-10.17-6.14-15.43-8.94c-1.23,1.75-2.63,3.51-4.03,5.26C554.68,672.38,557.14,673.79,559.59,675.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M454.93,778.1c-0.7,2.45-1.23,4.91-1.93,7.36C453.7,783.18,454.23,780.73,454.93,778.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M470.71,741.63c-2.63,4.73-5.08,9.47-7.36,14.55C465.62,750.93,467.9,746.19,470.71,741.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M559.59,675.01c-2.45-1.4-4.73-2.63-7.19-4.03c-1.4,1.75-2.8,3.51-4.21,5.08 C552.05,675.54,555.74,674.84,559.59,675.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M461.59,759.34c-1.58,3.68-2.98,7.54-4.38,11.22C458.61,766.88,460.19,763.2,461.59,759.34z"
}), React.createElement("path", {
  className: "st1",
  d: "M450.37,798.26l-18.23-10.52c4.03-37.17,25.07-75.21,53.65-98.7l-5.96-3.33 c-30.5,25.95-51.72,66.62-54.52,105.72l24.37,14.03c0.18-3.16,0.7-6.31,1.23-9.47C450.9,796.51,450.55,797.38,450.37,798.26z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,712.53c-2.81,3.16-5.61,6.49-8.24,9.99C485.61,719.02,488.77,715.86,491.57,712.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M496.48,706.75c1.05-1.05,2.28-2.1,3.33-3.16C498.76,704.64,497.71,705.69,496.48,706.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M481.05,725.33c-3.51,4.91-6.84,9.99-9.99,15.25C474.39,735.15,477.72,730.06,481.05,725.33z"
}), React.createElement("path", {
  className: "st2",
  d: "M478.42,659.76c0-2.1,0.18-4.38,0.53-6.66c0.35-2.8,0.88-5.61,1.4-8.59c0.18-0.7,0.35-1.4,0.53-2.28 c2.1-8.77,5.61-17.71,10.69-26.3c4.91-8.59,10.87-15.95,17.36-22.27c0.88-0.88,1.58-1.58,2.45-2.28c1.93-1.75,3.68-3.33,5.79-4.73 c2.1-1.58,4.03-2.98,6.14-4.21c0.18,0,0.18-0.18,0.35-0.18c0.35-0.18,0.7-0.18,1.05-0.53c2.45-1.4,4.91-2.98,7.54-3.86 c-6.14-3.33-11.92-6.49-14.73-6.84c-0.88-0.18-1.75-0.18-2.63-0.18c-19.46,0-41.2,25.6-49.97,50.84 c-5.43,15.78-6.84,35.24,5.26,42.78l8.77,5.08c-0.35-2.28-0.18-4.91-0.18-7.19c0-0.7-0.18-1.23-0.18-1.93 C478.42,660.64,478.42,660.29,478.42,659.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M466.85,670.46c-34.89-21.21,10.17-110.62,51.37-105.36c5.08,0.7,14.73,5.96,23.49,11.22 c6.49-0.7,12.8,0.18,18.06,3.33l0.18,0.18c0,0,0-0.18-0.18-0.18c-2.1-1.23-4.56-2.63-7.19-4.38 c-14.55-8.94-26.12-15.78-33.66-16.66c-27.17-3.33-55.4,27.52-66.44,59.43c-9.29,26.65-5.26,48.39,10.87,58.03l10.52,6.14 c1.75-1.58,3.33-3.16,5.08-4.56L466.85,670.46z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.19,687.81c-0.35,0.35-0.88,0.7-1.23,1.05l8.06,4.73C491.4,692.02,488.94,690.09,487.19,687.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M483.68,682.55c-0.53-1.05-1.05-2.1-1.58-3.16l-2.81-1.58c-1.75,1.4-3.33,2.98-5.08,4.56l5.79,3.33 C481.05,684.48,482.28,683.43,483.68,682.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.19,687.81c-1.4-1.58-2.45-3.51-3.51-5.43c-1.23,1.05-2.45,2.1-3.68,2.98l5.96,3.33 C486.14,688.34,486.66,687.99,487.19,687.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M478.77,662.74c0,2.45-0.18,4.91,0.18,7.19l-8.77-5.08c-12.27-7.36-10.69-27-5.26-42.78 c8.77-25.42,30.5-50.84,49.97-50.84c0.88,0,1.75,0,2.63,0.18c2.8,0.35,8.77,3.33,14.73,6.84c-2.63,0.88-5.08,2.45-7.54,3.86 c5.79-3.33,11.57-5.26,17.01-5.79c-8.77-5.26-18.41-10.69-23.49-11.22c-41.37-5.26-86.43,84.33-51.37,105.36l12.45,7.19 c0.53-0.53,1.23-0.88,1.75-1.23C479.65,672.03,478.95,667.83,478.77,662.74z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.1,593.84c0.88-0.7,1.58-1.58,2.45-2.28C510.68,592.44,509.98,592.97,509.1,593.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M478.42,659.76c0-2.1,0.35-4.38,0.53-6.66C478.95,655.38,478.77,657.66,478.42,659.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M481.05,642.41c-0.18,0.7-0.35,1.4-0.53,2.28C480.53,644.16,480.7,643.11,481.05,642.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M523.48,582.8c-2.1,1.23-4.21,2.63-6.14,4.21C519.27,585.43,521.37,583.85,523.48,582.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.12,677.47l2.81,1.58c-0.35-0.88-0.7-1.93-0.88-2.8C480.53,676.77,479.65,677.12,479.12,677.47z"
}), React.createElement("path", {
  className: "st0",
  d: "M574.14,691.49c-2.98-1.58-5.96-2.45-8.94-3.16c-0.7-0.18-1.4-0.18-2.1-0.18c-2.1-0.35-4.21-0.35-6.31-0.18 c-2.8,0.18-5.79,0.7-8.77,1.4c-1.4,0.35-2.8,0.53-4.21,1.05c-4.38,1.4-8.94,3.51-13.68,6.14c-13.5,8.24-25.77,19.81-36.11,33.31 c-0.18,0.18-0.35,0.53-0.53,0.7c-1.93,2.63-3.68,5.26-5.43,8.06c-1.58,2.45-3.33,4.91-4.91,7.36 c-5.61,9.64-10.34,19.81-14.02,30.15v0.18c-2.28,6.66-3.86,13.32-5.08,20.16l127.28-73.46 C589.57,707.97,583.79,696.93,574.14,691.49z"
}), React.createElement("path", {
  className: "st0",
  d: "M482.1,747.24c-5.43,9.29-9.64,19.11-12.97,28.75c3.51-10.52,8.24-20.69,14.03-30.15 C482.8,746.37,482.28,746.89,482.1,747.24z"
}), React.createElement("path", {
  className: "st0",
  d: "M543.99,690.27c1.58-0.53,2.8-0.7,4.21-1.05C546.62,689.57,545.57,689.92,543.99,690.27z"
}), React.createElement("path", {
  className: "st0",
  d: "M530.14,696.58c-12.97,7.54-25.42,19.11-36.11,33.31C504.19,716.39,516.82,704.64,530.14,696.58z"
}), React.createElement("path", {
  className: "st0",
  d: "M574.14,691.32c-2.63-1.58-5.79-2.45-8.94-3.16C568.53,689.04,571.51,690.09,574.14,691.32 C574.14,691.49,574.14,691.32,574.14,691.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M463.52,796.51l0.35-0.18c1.23-6.84,2.81-13.5,5.08-20.16C466.85,783.18,464.75,789.85,463.52,796.51z"
}), React.createElement("path", {
  className: "st0",
  d: "M558.72,687.64c-0.53,0-1.23,0.35-1.93,0.35c2.1-0.18,4.21,0,6.31,0.18 C561.87,687.99,560.47,687.64,558.72,687.64z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.89,738.48c1.75-2.63,3.51-5.43,5.43-8.06C491.57,732.87,489.82,735.85,487.89,738.48z"
}), React.createElement("path", {
  className: "st1",
  d: "M580.63,680.27c2.98,1.75,4.03,5.61,2.45,8.77c-0.18,0.35-0.53,0.35-0.88,0.7 c8.94,7.54,14.9,19.99,15.95,36.82l-135.34,78.19c-0.18,1.58-0.53,3.16-0.7,4.56c-0.18,2.1-1.4,4.03-3.33,5.08c0,0,0,0,0.18,0 l142.36-82.22c2.1-1.23,3.33-3.51,3.16-5.96C603.42,704.64,594.83,688.34,580.63,680.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M463.17,756.01c-0.53,1.23-1.05,2.28-1.58,3.33C462.12,758.11,462.64,757.06,463.17,756.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M500.16,703.59c2.45-2.28,4.91-4.56,7.36-6.66h-0.18C504.72,699.03,502.44,701.31,500.16,703.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,712.53c1.75-1.93,3.33-4.03,5.26-5.79C494.9,708.85,493.15,710.78,491.57,712.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M457.56,770.56c-0.88,2.45-1.75,4.91-2.45,7.54C455.81,775.65,456.51,773.19,457.56,770.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M470.71,741.63c0.18-0.35,0.35-0.7,0.53-1.05c-0.18,0.18-0.18,0.35-0.35,0.53 C470.71,740.93,470.71,741.46,470.71,741.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M483.16,722.7c-0.7,0.88-1.23,1.75-1.93,2.63C481.75,724.28,482.63,723.4,483.16,722.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M453.18,785.46c-0.88,3.51-1.58,6.84-2.1,10.17C451.42,792.12,452.12,788.79,453.18,785.46z"
}), React.createElement("path", {
  className: "st1",
  d: "M535.57,686.93c1.58-0.7,3.16-1.58,4.73-2.1c-1.23,0.53-2.45,1.05-3.68,1.58 C536.45,686.59,535.92,686.76,535.57,686.93z"
}), React.createElement("path", {
  className: "st1",
  d: "M474.04,749.17c-1.75,3.33-3.51,6.49-5.08,9.99C470.36,755.66,472.29,752.5,474.04,749.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M555.38,681.33c3.68-0.35,7.01,0,10.34,0.53C562.22,681.33,558.72,681.15,555.38,681.33z"
}), React.createElement("path", {
  className: "st1",
  d: "M486.49,729.19c-3.33,4.56-6.49,9.47-9.47,14.38C480,738.48,483.16,733.74,486.49,729.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M554.16,681.5c-3.86,0.35-7.71,1.23-11.57,2.63C546.62,682.55,550.3,681.68,554.16,681.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M462.12,809.31c0.18-1.58,0.53-2.98,0.7-4.56l-7.01,4.03l-5.96-3.51c0,1.05-0.35,2.1-0.35,3.16 c-0.18,2.28,1.05,4.56,2.98,5.79c1.05,0.7,2.28,1.05,3.51,1.05c1.05,0,2.1-0.35,3.16-0.88 C460.89,813.16,461.94,811.41,462.12,809.31z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.47,685.88c1.75,1.05,3.16,2.45,4.73,3.86c0.18-0.35,0.7-0.35,0.88-0.7c1.75-3.16,0.53-7.01-2.45-8.77 c-6.31-3.68-13.5-5.08-21.21-5.26C566.08,678.87,572.22,682.73,577.47,685.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M464.57,770.21c-0.53,1.4-1.23,2.98-1.75,4.38C463.17,773.19,464.05,771.61,464.57,770.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M494.73,718.84c-2.45,2.8-4.91,5.43-7.01,8.41C489.82,724.28,492.1,721.82,494.73,718.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.47,685.88c-2.98-1.58-5.96-2.63-8.94-3.33C571.86,683.43,574.85,684.31,577.47,685.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M464.57,770.21c1.4-3.86,2.81-7.54,4.38-11.22c1.58-3.33,3.33-6.66,5.08-9.99c0.88-1.58,1.58-3.33,2.45-4.91 c0.18-0.18,0.35-0.53,0.53-0.7c2.98-4.91,6.14-9.82,9.47-14.38c0.35-0.53,0.7-1.23,1.05-1.75c2.28-2.98,4.73-5.61,7.01-8.41 c8.59-9.99,17.88-18.41,27.52-24.72c-4.73,1.75-9.47,2.98-14.03,2.98c-0.35,0-0.53-0.18-0.88-0.18c-2.45,2.1-5.08,4.38-7.36,6.66 c-1.05,1.05-2.28,1.93-3.33,3.16c-1.75,1.75-3.51,3.86-5.26,5.79c-2.81,3.16-5.61,6.49-8.24,9.99c-0.7,0.88-1.23,1.75-1.93,2.63 c-3.51,4.91-6.84,9.82-9.99,15.25c-0.18,0.35-0.35,0.7-0.53,1.05c-2.81,4.73-5.08,9.64-7.36,14.55c-0.53,1.05-1.05,2.28-1.58,3.33 c-1.58,3.68-2.98,7.54-4.38,11.22c-0.88,2.45-1.75,4.91-2.45,7.54c-0.7,2.45-1.23,4.91-1.93,7.36c-0.88,3.33-1.58,6.84-2.1,10.17 c-0.53,3.16-0.88,6.31-1.23,9.47l5.96,3.51c0.7-11.04,3.16-22.62,7.01-34.01C463.17,773.19,464.05,771.61,464.57,770.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.02,676.07c-3.51,3.86-7.54,7.19-11.57,9.99c1.23-0.53,2.45-1.05,3.68-1.58c0.7-0.18,1.4-0.53,2.1-0.7 c3.86-1.23,7.71-2.1,11.57-2.63c0.35,0,0.88,0,1.23-0.18c3.33-0.18,6.84-0.18,10.34,0.53c1.05,0.18,1.93,0.53,2.98,0.7 c2.98,0.7,5.96,1.75,8.94,3.33c-5.26-2.98-11.57-7.01-17.88-10.87C555.74,674.84,552.05,675.54,548.02,676.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M468.95,776.35L468.95,776.35C469.13,776,468.95,776.35,468.95,776.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.37,689.21c2.98-0.7,5.96-1.23,8.77-1.4C554.33,687.99,551.18,688.69,548.37,689.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M530.14,696.58c4.73-2.63,9.29-4.56,13.68-6.14C539.78,691.67,535.22,693.77,530.14,696.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M563.1,687.99c0.7,0.18,1.4,0.18,2.1,0.18C564.5,688.16,563.98,688.16,563.1,687.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M574.32,691.49L574.32,691.49c9.29,5.43,15.25,16.48,16.83,31.38l-127.28,73.46c-0.53,2.8-0.88,5.43-1.23,8.24 l135.34-78.19c-1.05-16.83-7.01-29.28-15.95-36.82C580.46,692.02,577.3,693.07,574.32,691.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M493.32,730.59c0.18-0.18,0.35-0.53,0.53-0.7C493.67,729.89,493.67,730.06,493.32,730.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M483.16,746.02c1.58-2.63,3.16-4.91,4.91-7.36C486.49,740.76,484.56,743.21,483.16,746.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M568.53,682.55c-1.05-0.18-1.93-0.53-2.98-0.7c-3.33-0.53-6.66-0.7-10.34-0.53c-0.35,0-0.88,0-1.23,0.18 c-3.68,0.35-7.54,1.23-11.57,2.63c-0.7,0.18-1.4,0.53-2.1,0.7c-1.58,0.53-3.16,1.4-4.73,2.1c-1.75,1.23-3.51,2.63-5.43,3.86 c-2.63,1.58-5.08,2.45-7.71,3.33c-10.17,6.84-19.46,15.25-27.88,24.89c-2.28,2.8-4.73,5.43-7.01,8.41 c-0.35,0.53-0.7,1.23-1.05,1.75c-3.33,4.56-6.49,9.29-9.47,14.38c-1.05,1.75-1.93,3.68-2.98,5.61c-1.75,3.33-3.51,6.66-5.08,9.99 c-1.58,3.68-3.16,7.54-4.38,11.22c-0.53,1.4-1.23,2.98-1.75,4.38c-3.68,11.22-6.14,22.62-7.01,34.01l7.01-4.03 c0.35-2.8,0.7-5.43,1.23-8.24l-0.35,0.18c1.23-6.66,3.16-13.5,5.43-20.34v-0.18c3.33-9.64,7.54-19.28,12.97-28.75 c0.35-0.53,0.7-1.05,1.05-1.58c1.58-2.63,3.16-4.91,4.91-7.36c1.75-2.63,3.51-5.43,5.43-8.06c0.18-0.18,0.35-0.53,0.53-0.7 c10.87-14.2,23.14-25.77,36.12-33.31c4.91-2.63,9.47-4.73,13.68-6.14c1.4-0.53,2.8-0.7,4.21-1.05c2.98-0.7,5.96-1.4,8.77-1.4 c0.53,0,1.23-0.35,1.93-0.35c1.58,0,2.98,0.35,4.38,0.53c0.7,0.18,1.4,0.18,2.1,0.18c3.16,0.7,6.14,1.58,8.94,3.16l0,0h0.18 c2.63,1.4,5.96,0.53,7.71-1.93c-1.58-1.4-2.98-2.8-4.73-3.86C574.85,684.31,571.86,683.43,568.53,682.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M568.53,682.55c-1.05-0.18-1.93-0.53-2.98-0.7C566.61,681.85,567.48,682.38,568.53,682.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M494.73,718.84c8.24-9.64,17.71-18.06,27.88-24.89c-0.18,0-0.18,0.18-0.35,0.18 C512.61,700.43,503.14,708.85,494.73,718.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M474.04,749.17c1.05-1.93,1.93-3.86,2.98-5.61c-0.18,0.18-0.35,0.53-0.53,0.7 C475.62,745.84,474.92,747.24,474.04,749.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M468.95,759.17c-1.75,3.68-2.98,7.54-4.38,11.22C465.8,766.53,467.38,762.67,468.95,759.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.41,683.95c-0.7,0.18-1.4,0.53-2.1,0.7C541.18,684.48,541.89,684.31,542.41,683.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M455.81,808.6c0.88-11.4,3.33-22.79,7.01-34.01C458.79,785.99,456.51,797.56,455.81,808.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M554.16,681.5c0.35,0,0.88,0,1.23-0.18C555.03,681.5,554.51,681.5,554.16,681.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.71,727.43c-0.35,0.53-0.7,1.23-1.05,1.75C486.66,728.49,487.19,727.78,487.71,727.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M562.22,588.23c-0.18,0.35-0.7,0.53-1.05,0.88c4.73,5.08,7.54,12.97,7.54,23.32 c0,16.66-7.19,35.41-18.23,50.49c1.93,0.88,3.86,1.93,5.79,2.98c11.57-15.95,18.93-35.76,18.93-53.47 c0-15.25-5.43-26.82-15.43-32.61C563.1,581.57,563.98,585.08,562.22,588.23z"
}), React.createElement("path", {
  className: "st1",
  d: "M502.97,690.27c-0.18,0.35,0,0.88-0.18,1.23c-1.23,1.93-3.33,3.16-5.61,3.16c-1.05,0-2.28-0.35-3.16-0.88 l-0.18-0.18c0,0,0,0,0.18,0.18c4.03,2.28,8.42,3.33,13.15,3.51c3.68-2.98,7.36-5.61,11.22-8.06 C512.61,690.97,507.52,691.32,502.97,690.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M536.98,679.22c1.93-0.7,3.86-1.23,5.79-1.75c1.58-0.53,3.16-1.23,4.73-1.58c-1.93-1.05-3.86-1.75-5.79-2.63 c-2.63,2.63-5.43,5.08-8.24,7.19C534.7,679.92,535.92,679.4,536.98,679.22z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.44,668.18c1.93,0.88,3.86,1.93,5.96,2.98c1.4-1.75,2.8-3.33,4.03-5.26c-1.93-1.05-3.86-2.1-5.79-2.98 C549.25,664.85,547.85,666.25,546.44,668.18z"
}), React.createElement("path", {
  className: "st1",
  d: "M532.42,681.33c1.58-0.7,2.98-1.58,4.56-2.1c-1.05,0.53-2.28,0.88-3.33,1.23 C533.47,680.62,533.12,680.8,532.42,681.33z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.06,673.09c1.93,0.88,3.68,1.58,5.79,2.63c-1.75,0.35-3.16,1.05-4.73,1.58c1.75-0.53,3.51-0.88,5.26-1.23 c1.58-1.58,2.8-3.33,4.21-5.08c-1.93-1.05-4.03-2.1-5.96-2.98C545.04,669.75,543.46,671.51,542.06,673.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M523.48,582.8c0.35-0.18,0.88-0.35,1.23-0.7c-0.35,0.18-0.7,0.18-1.05,0.53 C523.65,582.62,523.65,582.8,523.48,582.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M478.42,660.64c0,0.7,0.18,1.23,0.18,1.93c0-0.88-0.18-1.93-0.18-2.8 C478.42,660.29,478.42,660.64,478.42,660.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,616.11c-4.91,8.59-8.42,17.53-10.69,26.3C483.33,633.46,487.19,624.52,491.57,616.11 c4.91-8.06,10.69-15.78,17.36-22.44C502.44,600.33,496.48,607.69,491.57,616.11z"
}), React.createElement("path", {
  className: "st1",
  d: "M480.53,644.86c-0.7,2.8-1.05,5.79-1.4,8.59C479.47,650.47,480,647.49,480.53,644.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M517.17,587.01c-1.93,1.4-3.86,2.98-5.79,4.73C513.49,589.81,515.24,588.41,517.17,587.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M484.91,660.64c0-5.61,1.05-11.4,2.45-17.18c-2.81,10.52-3.51,20.51-1.05,28.93l0.18-0.18 C485.61,669.05,484.91,665.02,484.91,660.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.57,582.62c1.4,0,2.63,0,3.86,0.18C548.02,582.62,546.79,582.8,545.57,582.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.94,582.62c-9.99,0.7-20.16,6.84-29.1,15.95c4.21-4.03,8.59-7.71,13.32-10.34 C532.59,584.9,537.85,582.97,542.94,582.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M541.89,576.31c5.79,3.51,11.22,6.84,14.9,8.94c1.75,1.05,3.33,2.28,4.73,3.86c0.35-0.35,0.7-0.35,1.05-0.88 c1.58-2.98,0.53-6.84-2.28-8.59l-0.18-0.18C554.51,576.31,548.55,575.43,541.89,576.31z"
}), React.createElement("path", {
  className: "st1",
  d: "M493.85,693.42L493.85,693.42c1.23,0.7,2.28,0.88,3.33,0.88c2.1,0,4.38-1.05,5.61-3.16 c0.18-0.35,0-0.88,0.18-1.23c-2.1-0.53-4.03-1.05-5.79-2.1l-5.79-3.33c-1.4,1.05-2.98,1.93-4.38,3.16 C488.94,690.09,491.4,692.02,493.85,693.42z"
}), React.createElement("path", {
  className: "st1",
  d: "M486.49,672.56c0.53,1.75,1.05,3.33,1.93,4.91c-0.7-1.58-1.23-3.33-1.58-5.08 C486.49,672.56,486.49,672.56,486.49,672.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M482.1,679.22c0.53,1.05,1.05,2.28,1.58,3.16c0.53-0.53,1.23-0.88,1.75-1.23L482.1,679.22z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,684.66l-6.14-3.51c-0.53,0.53-1.23,0.88-1.75,1.23c1.05,1.93,2.1,3.86,3.51,5.43 C488.41,686.76,489.99,685.88,491.57,684.66z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,683.25c-1.05-1.23-1.93-2.63-2.63-4.21C489.82,680.27,490.52,681.68,491.57,683.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M523.48,582.8c-2.1,1.23-4.21,2.8-6.14,4.21s-3.86,2.98-5.79,4.73c-0.88,0.7-1.58,1.58-2.45,2.28 c-6.49,6.49-12.45,14.2-17.18,22.44c-4.73,8.24-8.59,17.18-10.87,26.3c-0.18,0.7-0.35,1.4-0.53,2.28c-0.7,2.8-1.05,5.79-1.4,8.59 c-0.18,2.28-0.53,4.38-0.53,6.66c0,0.88,0,1.93,0.18,2.8c0.18,5.08,1.05,9.47,2.45,13.68c1.75-1.4,3.51-2.45,5.26-3.68 c-2.45-8.41-1.75-18.41,1.05-28.93c2.1-8.24,5.43-16.48,9.82-24.19c4.56-7.89,10.17-14.9,16.48-20.86 c9.12-9.12,19.28-15.25,29.1-15.95c0.88-0.18,1.75,0,2.8,0c1.23,0,2.63,0,3.86,0.18c2.63,0.35,5.08,1.23,7.19,2.45 c-3.68-2.1-9.12-5.43-14.9-8.94c-5.43,0.7-11.22,2.63-17.01,5.79C524.35,582.45,523.83,582.62,523.48,582.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M492.62,683.95c-0.35,0.18-0.7,0.35-0.88,0.7l5.79,3.33C495.43,686.93,493.85,685.71,492.62,683.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M488.77,678.52c-0.18-0.35-0.53-0.7-0.7-1.05c-0.7-1.58-1.4-3.33-1.93-4.91c-1.75,1.23-3.51,2.45-5.26,3.68 c0.35,0.88,0.53,1.93,0.88,2.8l3.33,1.93C486.49,680.27,487.71,679.4,488.77,678.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,683.25c-1.05-1.23-1.93-2.8-2.63-4.21c0-0.18-0.18-0.18-0.18-0.35c-1.23,0.88-2.28,1.58-3.51,2.45 l6.14,3.51c0.35-0.18,0.7-0.35,0.88-0.7C492.1,683.6,492.1,683.43,491.57,683.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.22,689.04c-3.86,2.45-7.54,5.08-11.22,8.06h0.18C510.85,694.3,514.71,691.49,518.22,689.04L518.22,689.04 z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.94,677.12c-1.93,0.53-3.86,1.05-5.79,1.75C538.91,678.34,541.01,677.99,542.94,677.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M526.98,690.97c2.98-1.75,5.79-2.8,8.59-4.03c0.35-0.18,0.7-0.35,0.88-0.7 C533.47,687.64,530.14,689.04,526.98,690.97z"
}), React.createElement("path", {
  className: "st1",
  d: "M536.63,686.06c4.03-2.98,7.89-6.31,11.57-9.99c-1.75,0.35-3.51,0.7-5.26,1.23c-1.93,0.53-3.86,1.05-5.79,1.75 c-1.4,0.53-2.98,1.4-4.56,2.1c-1.93,1.4-3.68,2.8-5.61,3.86c-2.98,1.75-5.79,2.98-8.59,3.86c-3.86,2.63-7.54,5.26-11.04,8.24 c0.35,0,0.53,0.18,0.88,0.18c4.38,0,9.12-1.23,14.03-2.98c1.58-1.05,3.16-2.45,4.73-3.33 C530.14,689.04,533.47,687.64,536.63,686.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M522.43,694.12c2.63-1.05,5.08-1.93,7.71-3.33c1.93-1.05,3.68-2.45,5.43-3.86c-2.8,1.23-5.79,2.28-8.59,4.03 C525.58,691.67,523.83,693.07,522.43,694.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M522.25,694.3c0.18,0,0.18-0.18,0.35-0.18c1.58-1.05,2.98-2.28,4.56-3.16 C525.41,691.67,523.65,693.25,522.25,694.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M492.45,651.52c0.35-1.93,0.88-3.86,1.4-5.79C493.15,647.49,492.62,649.59,492.45,651.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M553.81,590.86C553.46,590.86,553.46,590.86,553.81,590.86c5.61,3.33,8.77,10.87,8.77,21.39 c0,15.78-7.19,33.66-17.88,47.86c1.93,0.7,4.03,1.75,6.14,2.63c11.04-15.08,18.23-33.84,18.23-50.49c0-10.34-2.8-18.23-7.54-23.32 C559.42,591.39,556.44,592.44,553.81,590.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.22,602.96c1.4-1.23,2.63-2.63,4.21-3.86C521.02,600.33,519.62,601.56,518.22,602.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M544.34,589.11c-7.01,0.18-14.38,3.86-21.39,9.64c2.45-1.93,4.73-3.68,7.36-5.08 C535.4,590.69,539.96,589.46,544.34,589.11z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,660.64c0-2.8,0.18-5.79,0.7-8.94c-1.05,5.96-1.23,11.57-0.18,16.66c0,0,0,0,0.18,0 C491.57,666.07,491.57,663.62,491.57,660.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.27,589.11c2.45,0,4.56,0.7,6.49,1.75C550.83,589.64,548.55,589.29,546.27,589.11z"
}), React.createElement("path", {
  className: "st1",
  d: "M500.69,682.55C500.86,682.55,500.86,682.55,500.69,682.55c2.63,1.75,3.33,4.91,2.28,7.71 c4.56,1.05,9.64,0.7,15.25-1.23c1.75-1.23,3.51-2.63,5.43-3.68l0,0c0,0,0,0,0.18,0c2.98-1.75,6.31-3.33,9.82-4.73 c2.8-2.1,5.61-4.56,8.24-7.19c-2.45-1.05-4.73-1.75-7.01-2.28c-3.51,3.33-7.36,6.31-11.22,8.59 C514.71,684.66,506.47,685.71,500.69,682.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M492.1,668.35L492.1,668.35c0.35,1.93,0.88,3.68,1.58,5.43C493.15,672.03,492.62,670.46,492.1,668.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M539.96,665.9c2.1,0.7,4.21,1.4,6.31,2.28c1.4-1.75,2.98-3.33,4.21-5.26c-2.1-1.05-4.03-1.93-6.14-2.63 C543.29,662.04,541.54,663.97,539.96,665.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M523.83,685.01C523.83,685.36,523.65,685.36,523.83,685.01c2.8-1.58,5.79-2.63,8.77-4.03 c0.35-0.35,0.7-0.53,1.05-0.7C530.14,681.85,526.81,683.6,523.83,685.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M534.87,670.81c2.1,0.53,4.38,1.23,7.01,2.28c1.58-1.58,2.98-3.33,4.56-5.08c-2.28-1.05-4.21-1.58-6.31-2.28 C538.55,667.48,536.8,669.23,534.87,670.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M496.3,678.17c-0.53-0.7-0.88-1.4-1.4-2.28C495.25,676.94,495.78,677.47,496.3,678.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.57,582.62c-0.88,0-1.75,0-2.8,0c-4.91,0.53-10.17,2.28-15.78,5.61c-4.73,2.63-9.12,6.31-13.32,10.34 c-11.92,11.92-21.74,28.75-26.12,45.06c-1.58,5.79-2.45,11.57-2.45,17.18c0,4.38,0.7,8.06,1.58,11.57 c1.75-1.23,3.68-2.63,5.43-3.86c-1.05-4.91-0.88-10.52,0.18-16.66c0-0.18,0-0.35,0-0.53c0.35-1.93,0.88-3.86,1.4-5.79 c1.93-7.54,4.91-15.43,9.29-22.97c4.38-7.71,9.64-14.2,15.43-19.64c1.4-1.4,2.8-2.63,4.21-3.86c0.18-0.18,0.35-0.35,0.53-0.35 c7.01-5.96,14.38-9.47,21.39-9.64c0.53,0,0.88-0.18,1.4-0.18c0.18,0,0.35,0.18,0.53,0.18c2.28,0.18,4.38,0.7,6.49,1.75 c0.18,0.18,0.35,0,0.53,0.18l0,0h0.18c2.63,1.4,5.79,0.35,7.71-1.93c-1.4-1.58-2.98-2.8-4.73-3.86c-2.28-1.23-4.73-1.93-7.19-2.45 C548.37,582.62,546.79,582.62,545.57,582.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M500.86,682.55L500.86,682.55C500.69,682.55,500.69,682.55,500.86,682.55c-1.23-0.7-1.93-1.58-2.81-2.45 c-1.75,1.23-3.51,2.45-5.26,3.68c1.4,1.4,2.81,2.98,4.73,4.03c1.75,1.05,3.68,1.75,5.79,2.1 C504.02,687.29,503.49,684.31,500.86,682.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M494.2,674.84c-0.18-0.35-0.35-0.7-0.53-1.05c-0.7-1.58-1.23-3.51-1.58-5.26c-1.93,1.23-3.68,2.63-5.43,3.86 c0.53,1.75,0.88,3.68,1.58,5.08c0.18,0.35,0.53,0.7,0.7,1.05C490.52,677.29,492.45,675.89,494.2,674.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M498.06,680.27c-0.53-0.53-1.23-1.23-1.75-1.93c-0.53-0.7-0.88-1.58-1.4-2.28c-0.18-0.35-0.53-0.7-0.7-1.23 c-1.75,1.23-3.51,2.45-5.26,3.68c0,0.18,0.18,0.18,0.18,0.35c0.88,1.58,1.75,2.98,2.63,4.21c0.18,0.35,0.7,0.53,0.88,0.88 C494.38,682.55,495.95,681.33,498.06,680.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.66,598.4c-6.14,5.96-11.92,13.15-16.48,20.86c-4.38,7.71-7.71,15.95-9.82,24.19 C492.1,627.33,501.91,610.32,513.66,598.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M556.61,585.08c-2.1-1.23-4.56-1.93-7.19-2.45C552.05,583.15,554.33,583.85,556.61,585.08z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.94,582.62c0.88,0,1.75,0,2.8,0C544.52,582.62,543.64,582.62,542.94,582.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M492.62,683.95c1.4,1.58,2.98,2.98,4.91,4.03C495.43,686.93,494.2,685.53,492.62,683.95 C492.62,683.78,492.62,683.95,492.62,683.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M488.24,677.47c0.18,0.35,0.53,0.7,0.7,1.05l0,0C488.77,678.17,488.24,677.99,488.24,677.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M488.77,678.52L488.77,678.52c0,0.18,0.18,0.18,0.18,0.35C488.94,678.87,488.77,678.87,488.77,678.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.57,683.25c0.18,0.35,0.53,0.7,0.7,0.88c0,0,0.18,0,0.18-0.18C492.45,683.6,492.1,683.43,491.57,683.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M523.65,685.36L523.65,685.36c-1.93,1.05-3.68,2.63-5.43,3.68c0,0,0,0,0.18,0 C520.32,687.81,521.72,686.59,523.65,685.36L523.65,685.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M523.65,685.36c-1.75,1.05-3.51,2.45-5.26,3.68c2.8-0.88,5.61-2.28,8.59-3.86c1.93-1.05,3.68-2.45,5.61-3.86 C529.79,682.55,526.81,683.6,523.65,685.36L523.65,685.36z"
}), React.createElement("path", {
  className: "st0",
  d: "M497.53,260.04c-7.01,0-13.5-1.58-19.28-4.91l-13.85-8.06c-43.83,35.24-75.91,93.62-81.52,149.89l32.43,18.58 c0.18-1.4,0.53-2.81,0.88-4.21c0.88-5.61,1.75-11.4,3.16-17.18c0.7-2.98,1.4-5.96,2.28-8.94c1.23-4.38,2.63-8.77,4.03-13.32 c1.75-5.08,3.68-10.17,5.79-15.25c0.88-2.28,1.93-4.56,2.98-6.66c2.98-6.66,6.31-13.15,9.99-19.46c0.35-0.7,0.7-1.4,1.05-2.1 c0.18-0.35,0.53-0.88,0.88-1.23c4.38-7.36,8.94-14.55,14.03-21.39c0.88-1.05,1.58-2.28,2.28-3.33c4.03-5.26,8.24-10.34,12.8-15.25 c2.1-2.45,4.21-5.08,6.49-7.36c1.75-1.75,3.68-3.33,5.61-5.08c6.14-5.96,12.45-11.4,18.93-16.13 C503.14,259.34,500.34,260.04,497.53,260.04z"
}), React.createElement("path", {
  className: "st0",
  d: "M545.92,237.25c0.88-0.35,1.75-0.53,2.8-0.7c1.75-0.53,3.33-1.05,5.08-1.4c1.58-0.35,3.16-0.53,4.91-0.88 c1.93-0.35,3.68-0.88,5.61-1.05c-3.16-1.75-6.31-3.51-9.29-4.91C552.05,231.47,549.07,234.27,545.92,237.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M369.38,400.12c-0.18,2.45,1.05,4.91,3.16,6.14l44.71,25.77c1.05,0.53,2.1,0.88,3.16,0.88 c-1.23,0-2.28-0.35-3.33-1.05c-2.1-1.23-3.16-3.51-3.16-5.79c0-1.05,0.35-2.1,0.35-3.16l-38.57-22.26 c4.38-58.2,36.29-119.04,82.4-156.91l-5.79-3.33C406.19,278.98,373.93,339.81,369.38,400.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M423.55,432.03C423.55,432.03,423.55,431.85,423.55,432.03c-0.88,0.53-1.93,0.7-3.16,0.7 C421.44,432.9,422.5,432.55,423.55,432.03z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.3,233.39c8.94,0.7,17.18,3.16,24.72,7.54c-4.03-2.28-8.41-5.08-12.97-7.89 c-8.06-5.08-16.83-10.34-25.42-14.73c-1.4,1.75-2.8,3.33-4.21,5.08C565.2,226.03,571.51,229.71,577.3,233.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M444.06,330.52c-3.68,6.31-6.84,12.8-9.99,19.46C437.22,343.67,440.55,337.18,444.06,330.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M553.98,235.15c-1.75,0.35-3.51,0.88-5.08,1.4C550.65,235.85,552.05,235.32,553.98,235.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M421.44,385.39c-0.88,2.98-1.58,5.96-2.28,8.94C419.87,391.35,420.74,388.55,421.44,385.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M431.26,356.82c-2.1,5.08-4.03,10.17-5.79,15.25C427.41,367.16,429.16,361.9,431.26,356.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M564.33,233.04c-1.93,0.18-3.86,0.7-5.61,1.05c6.31-1.05,12.62-1.4,18.41-0.88 c-5.79-3.51-11.92-7.01-17.88-10.17c-1.4,1.75-2.8,3.51-4.21,5.08C558.37,229.71,561.17,231.29,564.33,233.04z"
}), React.createElement("path", {
  className: "st1",
  d: "M475.27,287.22c-4.38,4.91-8.77,9.82-12.8,15.25C466.5,297.03,470.88,292.13,475.27,287.22z"
}), React.createElement("path", {
  className: "st1",
  d: "M415.31,415.55l-32.43-18.58c5.43-56.28,37.69-114.66,81.52-149.89l-5.96-3.51 c-46.11,37.87-78.02,98.7-82.4,156.91l38.57,22.26c0.35-3.68,0.88-7.54,1.4-11.4C415.83,412.74,415.31,414.32,415.31,415.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M481.75,280.03c1.75-1.93,3.68-3.33,5.61-5.08C485.43,276.7,483.68,278.1,481.75,280.03z"
}), React.createElement("path", {
  className: "st1",
  d: "M460.19,305.8c-5.08,6.84-9.82,14.03-14.03,21.39C450.37,319.65,455.28,312.46,460.19,305.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M460.36,184.13c3.16-12.8,8.06-25.77,15.43-38.22c7.01-12.1,15.43-22.62,24.54-31.38 c2.63-2.81,5.43-5.26,8.42-7.71c0.18-0.18,0.35-0.18,0.53-0.35c9.82-8.24,20.34-14.38,31.21-16.83 c-11.04-6.49-23.14-13.15-28.93-13.85c-1.4-0.18-2.98-0.35-4.38-0.35c-30.5,0-62.76,38.74-75.91,76.61 c-10.87,31.38-7.54,56.1,8.94,66.09l18.76,10.87c-2.98-10.17-2.98-21.91-0.88-34.01c0.18-0.7,0.35-1.58,0.35-2.28 C459.14,189.74,459.66,186.94,460.36,184.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M436.7,223.75C385.5,192.72,451.42,61.76,512.08,69.3c8.41,1.05,25.07,10.69,39.27,19.28 c7.19-0.18,14.03,1.23,19.99,4.56c-2.8-1.75-6.49-3.86-10.69-6.49c-20.16-12.27-37.69-22.62-47.86-24.02 c-38.92-4.91-78.37,39.45-94.14,85.03c-12.97,37.52-7.54,68.2,14.73,81.52l18.93,10.87c1.75-1.4,3.51-2.98,5.26-4.38L436.7,223.75z "
}), React.createElement("path", {
  className: "st1",
  d: "M467.38,244.97c-1.05,0.7-2.1,1.4-2.98,2.1l13.85,8.06C473.86,252.68,470.18,249,467.38,244.97z"
}), React.createElement("path", {
  className: "st1",
  d: "M463.69,239.53c0-0.18-0.18-0.18-0.18-0.35l-5.79-3.33c-1.75,1.4-3.51,2.98-5.26,4.38l5.79,3.33 C460.19,242.34,461.94,241.11,463.69,239.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M467.38,244.97c-1.23-1.75-2.45-3.51-3.51-5.43c-1.75,1.4-3.68,2.63-5.43,4.03l5.96,3.51 C465.27,246.19,466.33,245.67,467.38,244.97z"
}), React.createElement("path", {
  className: "st1",
  d: "M500.34,114.53c2.81-2.63,5.43-5.43,8.42-7.71C505.77,109.1,502.97,111.55,500.34,114.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M460.36,184.13c-0.7,2.81-1.4,5.79-1.93,8.59C458.79,189.74,459.84,186.94,460.36,184.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M456.86,209.55c0-4.73,0.35-9.64,1.23-14.73c-2.1,12.1-2.1,23.84,0.88,34.01l-18.76-10.87 c-16.48-9.99-19.81-34.71-8.94-66.09c13.15-37.87,45.23-76.61,75.91-76.61c1.4,0,2.98,0.18,4.38,0.35 c5.79,0.7,17.71,7.19,28.93,13.85c-10.69,2.45-21.39,8.59-31.21,16.83c4.03-3.33,8.24-6.14,12.62-8.77 c10.34-5.96,20.51-8.77,29.8-8.94c-14.2-8.59-30.86-18.23-39.27-19.28c-60.66-7.54-126.58,123.42-75.39,154.45l21.04,12.1 c1.05-0.88,2.28-1.58,3.33-2.28C458.61,226.56,456.86,218.84,456.86,209.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M457.73,235.85l5.79,3.33c-0.88-1.75-1.58-3.68-2.45-5.61C459.84,234.27,458.79,235.15,457.73,235.85z"
}), React.createElement("path", {
  className: "st0",
  d: "M595.71,251.8c-0.35-0.18-0.7-0.35-1.05-0.53c-2.45-1.4-5.08-2.28-7.89-3.16c-1.4-0.53-2.8-0.88-4.21-1.23 c-3.33-0.7-6.84-1.23-10.52-1.23c-0.35,0-0.53,0-0.88,0c-2.8,0-5.79,0.35-8.77,0.7c-0.53,0.18-1.23,0.18-1.75,0.35 c-2.45,0.35-4.73,1.05-7.19,1.75c-1.4,0.35-2.98,0.88-4.38,1.4c-1.05,0.35-2.1,0.88-3.16,1.23c-5.43,2.1-11.22,4.73-17.36,8.06 c-19.99,12.1-38.22,29.1-53.47,48.91c-0.35,0.53-0.88,1.05-1.23,1.58c-2.63,3.51-5.08,7.36-7.54,11.22 c-2.63,4.03-5.43,7.89-7.89,11.92c-12.62,21.39-22.09,44.88-27.17,68.72c-0.18,0.53-0.18,1.05-0.35,1.58 c-0.7,3.68-1.05,7.36-1.58,10.87l193.55-111.68C620.08,278.45,610.61,260.57,595.71,251.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M528.04,259.34c6.14-3.33,11.92-5.96,17.36-8.06C539.96,253.21,534.17,256.01,528.04,259.34z"
}), React.createElement("path", {
  className: "st0",
  d: "M582.56,247.24c1.4,0.35,2.8,0.7,4.21,1.23C585.19,247.77,583.79,247.42,582.56,247.24z"
}), React.createElement("path", {
  className: "st0",
  d: "M456.51,334.9c-12.45,21.74-21.21,44.71-25.77,66.62c5.08-23.67,14.55-47.16,27.17-68.72 C457.56,333.68,457.03,334.38,456.51,334.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M595.71,251.8L595.71,251.8c-0.35-0.18-0.7-0.35-1.05-0.53C594.83,251.63,595.18,251.63,595.71,251.8 L595.71,251.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M428.46,414.32l0.53-0.35c0.53-3.68,0.88-7.36,1.58-10.87C429.51,406.78,428.63,410.64,428.46,414.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M528.04,259.34c-19.28,11.04-37.52,28.23-53.47,48.91C489.82,288.44,508.05,271.44,528.04,259.34z"
}), React.createElement("path", {
  className: "st0",
  d: "M571.69,246.02c-0.18,0-0.53,0-0.7,0C571.34,246.02,571.51,246.02,571.69,246.02L571.69,246.02z"
}), React.createElement("path", {
  className: "st0",
  d: "M465.8,321.05c2.45-3.68,4.91-7.54,7.54-11.22C470.71,313.51,468.08,317.37,465.8,321.05z"
}), React.createElement("path", {
  className: "st0",
  d: "M548.72,250.05c1.58-0.53,2.98-0.88,4.38-1.4C551.7,249,550.13,249.52,548.72,250.05z"
}), React.createElement("path", {
  className: "st0",
  d: "M560.47,247.07c0.53-0.18,1.23-0.18,1.75-0.35C561.7,246.72,560.82,246.72,560.47,247.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M604.65,249.52c-0.18,0.35-0.7,0.35-0.88,0.7c14.38,10.87,24.02,29.63,25.6,55.75L427.93,422.21 c-0.18,1.58-0.53,3.16-0.7,4.56c-0.18,2.1-1.4,4.03-3.33,5.08l0,0l208.63-120.44c2.1-1.23,3.33-3.51,3.16-5.96 c-1.75-30.33-13.68-53.3-33.66-64.87C605,242.34,606.4,246.54,604.65,249.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M434.42,350.15c-1.05,2.28-1.93,4.56-2.98,6.66C432.31,354.71,433.37,352.43,434.42,350.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M558.72,234.1c-1.58,0.35-3.16,0.53-4.91,0.88C555.38,234.62,557.31,234.27,558.72,234.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M425.65,372.24c-1.58,4.38-2.81,8.94-4.03,13.32C422.67,381.01,424.07,376.63,425.65,372.24z"
}), React.createElement("path", {
  className: "st1",
  d: "M419.17,394.51c-1.4,5.79-2.45,11.4-3.16,17.18C416.89,405.55,417.76,400.12,419.17,394.51z"
}), React.createElement("path", {
  className: "st1",
  d: "M462.47,302.47c-0.88,1.05-1.58,2.28-2.28,3.33C460.89,304.75,461.59,303.7,462.47,302.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.19,274.77c6.14-5.79,12.45-11.22,19.11-16.13h-0.18C499.63,263.55,493.67,268.81,487.19,274.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M475.27,287.22c2.1-2.45,4.21-5.08,6.49-7.36C479.47,282.31,477.37,284.94,475.27,287.22z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.74,237.43c0.88-0.35,1.93-0.7,2.98-0.88C547.67,236.9,546.79,236.9,545.74,237.43 C545.92,237.43,545.74,237.43,545.74,237.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M444.06,330.52c0.7-1.05,1.23-2.28,1.93-3.51c-0.18,0.35-0.53,0.88-0.88,1.23 C444.94,329.29,444.59,329.99,444.06,330.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M439.85,353.66c2.63-5.96,5.79-11.75,8.94-17.36C445.46,342.09,442.31,347.7,439.85,353.66z"
}), React.createElement("path", {
  className: "st1",
  d: "M451.42,331.05c4.03-7.01,8.59-13.67,13.15-20.16C459.84,317.37,455.46,324.03,451.42,331.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M466.85,307.55c3.33-4.56,7.01-8.59,10.52-12.8C473.86,299.14,470.18,303.17,466.85,307.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M566.43,239.71c1.93-0.18,3.86-0.18,5.79-0.18C570.46,239.53,568.53,239.53,566.43,239.71z"
}), React.createElement("path", {
  className: "st1",
  d: "M598.86,246.19c1.75,1.05,3.16,2.63,4.73,3.86c0.18-0.35,0.7-0.35,0.88-0.7c1.75-3.16,0.53-7.01-2.45-8.77 c-7.54-4.38-15.95-6.66-24.72-7.54C585.01,237.95,592.55,242.51,598.86,246.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M556.61,241.11c2.45-0.53,4.73-0.88,7.19-1.23C561.7,240.06,559.07,240.76,556.61,241.11z"
}), React.createElement("path", {
  className: "st1",
  d: "M540.83,246.19c0.88-0.35,1.93-0.88,2.8-1.05C542.59,245.14,541.89,245.67,540.83,246.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M578.35,240.06c0.7,0,1.58,0.18,2.28,0.18C579.58,240.06,579.05,240.06,578.35,240.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M427.05,426.94c0.18-1.58,0.53-3.16,0.7-4.56l-7.19,4.21l-5.96-3.51c0,1.05-0.35,2.1-0.35,3.16 c-0.18,2.28,1.05,4.56,3.16,5.79c1.05,0.7,2.28,1.05,3.33,1.05c1.23,0,2.28-0.35,3.16-0.88 C425.65,430.8,426.88,429.05,427.05,426.94z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.37,243.39c1.93-0.7,4.03-1.23,5.96-1.75C552.23,242.16,550.13,242.86,548.37,243.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M430.74,376.63c1.05-2.98,2.28-5.79,3.33-8.59C432.84,371.02,431.79,373.82,430.74,376.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M430.74,376.63c0.88-2.98,2.28-5.79,3.33-8.59c1.75-4.73,3.51-9.64,5.61-14.38 c2.63-5.96,5.79-11.75,8.94-17.36c0.88-1.58,1.4-3.16,2.28-4.56c0.18-0.18,0.35-0.35,0.35-0.7c4.03-7.01,8.59-13.67,13.15-20.16 c0.7-1.05,1.4-2.1,2.1-3.16c3.33-4.38,7.01-8.59,10.52-12.8c12.62-14.73,26.65-27.52,41.73-37.17l-2.98-1.75 c-3.33,1.23-6.49,1.93-9.47,2.63c-6.66,4.91-12.97,10.34-19.11,16.13c-1.75,1.75-3.68,3.33-5.61,5.08 c-2.28,2.28-4.38,4.91-6.49,7.36c-4.38,4.91-8.77,9.82-12.8,15.25c-0.88,1.05-1.58,2.28-2.28,3.33 c-4.91,6.84-9.64,14.03-14.03,21.39c-0.7,1.05-1.23,2.28-1.93,3.51c-3.68,6.49-6.84,12.97-9.99,19.46 c-1.05,2.28-1.93,4.56-2.98,6.66c-2.1,5.08-4.03,10.17-5.79,15.25c-1.58,4.38-2.81,8.77-4.03,13.32c-0.88,2.98-1.58,5.96-2.28,8.94 c-1.23,5.61-2.28,11.4-3.16,17.18c-0.53,3.86-1.23,7.71-1.4,11.4l5.96,3.51C421.44,410.11,425.13,393.46,430.74,376.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M558.72,234.1c-1.58,0.35-3.33,0.53-4.91,0.88c-1.75,0.35-3.51,1.05-5.08,1.4c-1.05,0.35-1.93,0.53-2.98,0.88 c-5.26,4.73-10.52,8.94-16.13,12.27c0.35,0.35,0.53,0.7,0.88,1.05c3.51-1.75,6.84-3.33,10.17-4.73c0.88-0.35,1.93-0.7,2.8-1.05 c1.58-0.53,3.16-1.05,4.73-1.58c1.93-0.7,4.03-1.23,5.96-1.75c0.88-0.18,1.58-0.35,2.45-0.53c2.45-0.53,4.73-0.88,7.19-1.23 c0.88-0.18,1.75-0.18,2.63-0.18c1.93-0.18,3.86-0.18,5.79-0.18c1.93,0,3.86,0.18,5.79,0.35c0.7,0.18,1.58,0.18,2.28,0.18 c6.66,1.05,12.8,2.98,18.41,6.14c-6.49-3.68-13.85-8.42-21.56-13.15C571.34,232.87,565.2,233.04,558.72,234.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M529.79,251.1c-1.58,0.88-3.16,1.58-4.73,2.45l0,0C526.63,252.68,528.04,252.15,529.79,251.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M524.7,253.73c-0.53,0.35-1.05,0.88-1.58,1.23C523.65,254.43,524.35,253.91,524.7,253.73L524.7,253.73z"
}), React.createElement("path", {
  className: "st1",
  d: "M528.04,250.58c-1.58,0.88-3.16,1.23-4.73,2.1l1.4,0.88c1.58-0.88,3.16-1.58,4.73-2.45 c0.35-0.18,0.7-0.35,0.88-0.53c-0.18-0.35-0.53-0.7-0.88-1.05C529.09,250.05,528.74,250.58,528.04,250.58L528.04,250.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M524.7,253.73l-1.58-0.88c-2.45,1.23-4.91,2.28-7.36,3.16l2.98,1.75c1.4-0.88,2.8-2.1,4.21-2.98 C523.65,254.43,524.35,253.91,524.7,253.73z"
}), React.createElement("polygon", {
  className: "st1",
  points: "524.88,253.73 524.7,253.73 524.7,253.91  "
}), React.createElement("polygon", {
  className: "st1",
  points: "523.48,252.68 523.48,252.85 524.7,253.73 524.88,253.73  "
}), React.createElement("path", {
  className: "st1",
  d: "M586.42,248.3c2.8,0.88,5.43,1.75,7.89,3.16C591.85,250.05,589.4,249,586.42,248.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M562.05,246.72c2.98-0.53,5.96-0.7,8.77-0.7C568.18,246.02,565.2,246.19,562.05,246.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.86,246.02c3.68,0,7.19,0.53,10.52,1.23C579.05,246.19,575.37,246.02,571.86,246.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M553.11,248.82c2.45-0.7,4.91-1.23,7.19-1.75C558.01,247.24,555.56,247.95,553.11,248.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M457.73,332.8c2.45-4.21,5.26-8.06,7.89-11.92C462.99,325.08,460.19,328.94,457.73,332.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M430.56,403.28c0.18-0.53,0.18-1.05,0.35-1.58C430.74,402.22,430.56,402.75,430.56,403.28z"
}), React.createElement("path", {
  className: "st1",
  d: "M473.34,309.66c0.35-0.53,0.88-1.05,1.23-1.58C474.04,308.78,473.86,309.13,473.34,309.66z"
}), React.createElement("path", {
  className: "st1",
  d: "M595.88,252.15c0,0-0.18,0-0.18-0.18c15.08,8.77,24.54,26.47,26.82,50.32L428.98,413.97 c-0.35,2.63-0.88,5.43-1.23,8.06L629.19,305.8c-1.58-26.12-11.22-44.88-25.6-55.75C601.67,252.68,598.51,253.38,595.88,252.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.57,251.1c1.05-0.35,2.1-0.88,3.16-1.23C547.67,250.4,546.62,250.93,545.57,251.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M578.35,240.06c-1.93-0.18-3.86-0.35-5.79-0.35c-1.93,0-3.86,0-5.79,0.18c-0.88,0-1.75,0.18-2.63,0.18 c-2.28,0.35-4.73,0.7-7.19,1.23c-0.88,0.18-1.58,0.35-2.45,0.53c-1.93,0.53-4.03,1.05-5.96,1.75c-1.58,0.53-3.16,1.05-4.73,1.58 c-0.88,0.35-1.93,0.7-2.8,1.05c-3.51,1.4-6.84,2.98-10.17,4.73c0.35,0.88,0.7,1.75,0.88,2.63c0,2.28-1.05,4.38-2.98,5.61l0,0 c-1.05,0.7-2.45,1.05-3.51,1.05c-1.05,0-2.28-0.35-3.33-0.88l-2.63-1.4c-15.25,10.17-29.28,22.79-41.73,37.17 c-3.51,4.21-7.19,8.24-10.52,12.8c-0.7,1.05-1.4,2.1-2.1,3.16c-4.73,6.49-9.12,13.32-13.15,20.16c-1.05,1.75-1.75,3.51-2.81,5.26 c-3.16,5.79-6.14,11.57-8.94,17.36c-2.1,4.73-3.86,9.47-5.61,14.38c-1.05,2.81-2.28,5.79-3.33,8.59 c-5.43,16.48-8.94,33.13-10.17,49.79l7.19-4.21c0.35-2.63,0.7-5.43,1.23-8.06l-0.53,0.35c0.53-3.68,1.4-7.54,2.1-11.22 c0.18-0.53,0.18-1.05,0.35-1.58c4.56-22.09,13.32-44.88,25.77-66.62c0.35-0.7,0.88-1.23,1.23-1.93c2.45-4.21,5.08-8.06,7.89-11.92 c2.45-3.68,4.91-7.71,7.54-11.22c0.35-0.53,0.88-1.05,1.23-1.58c15.95-20.86,34.36-37.87,53.47-48.91 c5.96-3.33,11.75-5.96,17.36-8.06c1.05-0.35,2.1-0.88,3.16-1.23c1.58-0.53,2.98-0.88,4.38-1.4c2.45-0.7,4.91-1.23,7.19-1.75 c0.53-0.18,1.23-0.18,1.75-0.35c2.98-0.53,5.96-0.7,8.77-0.7c0.18,0,0.53,0,0.7,0h0.18c3.68,0,7.19,0.53,10.52,1.23 c1.4,0.35,2.8,0.7,4.21,1.23c2.63,0.88,5.26,1.93,7.89,3.16c0.35,0.18,0.7,0.18,1.05,0.53l0,0l0,0c0,0,0.18,0,0.18,0.18 c2.8,1.4,5.79,0.53,7.89-1.93c-1.58-1.23-2.98-2.81-4.73-3.86c-6.14-3.16-12.27-5.26-18.41-6.14 C579.58,240.06,579.05,240.06,578.35,240.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M433.89,367.86c1.75-4.73,3.51-9.64,5.61-14.38C437.4,358.39,435.82,363.3,433.89,367.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M572.57,239.53c1.93,0,3.86,0.18,5.79,0.35C576.25,239.71,574.32,239.53,572.57,239.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M554.33,241.81c0.88-0.18,1.58-0.35,2.45-0.53C556.09,241.28,555.21,241.28,554.33,241.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M563.98,240.06c0.88-0.18,1.75-0.18,2.63-0.18C565.55,239.71,564.85,239.71,563.98,240.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M451.07,331.57c-0.88,1.58-1.58,3.16-2.28,4.56c0.88-1.75,1.75-3.51,2.81-5.26 C451.07,331.22,451.07,331.57,451.07,331.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M519.1,257.76L519.1,257.76c-15.08,9.64-29.1,22.26-41.73,37.17C489.82,280.55,503.67,268.11,519.1,257.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M464.57,310.88c0.7-1.05,1.4-2.1,2.1-3.16C466.15,308.61,465.27,309.66,464.57,310.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M540.83,246.19c-3.33,1.4-6.84,2.98-10.17,4.73l0,0C533.82,249,537.5,247.42,540.83,246.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M420.39,426.42c1.23-16.48,4.73-33.31,10.17-49.79C425.13,393.46,421.44,410.11,420.39,426.42z"
}), React.createElement("path", {
  className: "st1",
  d: "M598.86,246.19c-5.61-3.16-11.75-5.26-18.41-6.14C586.42,241.28,592.55,243.04,598.86,246.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.46,244.97c1.58-0.53,3.16-1.05,4.73-1.58C546.62,243.91,545.22,244.44,543.46,244.97z"
}), React.createElement("path", {
  className: "st1",
  d: "M524.7,253.91c-0.53,0.35-1.05,0.88-1.75,1.23c-1.4,0.88-2.8,1.93-4.21,2.98l2.63,1.4 c1.05,0.53,2.1,0.88,3.33,0.88c1.23,0,2.45-0.35,3.51-1.05l0,0c1.93-1.23,2.98-3.33,2.98-5.61c0-1.05-0.35-1.93-0.88-2.63 c-0.35,0.18-0.7,0.35-0.88,0.53C528.04,252.15,526.63,252.68,524.7,253.91z"
}), React.createElement("path", {
  className: "st1",
  d: "M530.49,250.93L530.49,250.93c-0.35,0.18-0.7,0.35-0.88,0.53C529.96,251.1,530.14,250.93,530.49,250.93z"
}), React.createElement("path", {
  className: "st1",
  d: "M523.3,254.96c-1.4,0.88-2.8,1.93-4.21,2.98l0,0C520.32,257.06,521.72,255.83,523.3,254.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M573.97,102.08c-0.18,0.35-0.7,0.53-0.88,0.7c8.24,7.36,13.32,19.46,13.32,35.94 c0,19.64-6.84,41.37-18.06,60.66c-3.16,5.61-6.84,10.87-10.69,15.95c2.1,0.88,4.03,1.75,6.14,2.98c3.68-4.91,7.19-9.99,10.34-15.6 c12.1-21.04,18.93-43.83,18.93-63.82c0-21.39-7.54-37.52-21.21-45.41c0,0,0,0-0.18,0l0,0C574.67,94.9,575.9,98.75,573.97,102.08z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.19,251.63c-0.18,0.35,0,0.88-0.18,1.23c-1.23,1.93-3.33,3.16-5.61,3.16c-1.05,0-2.28-0.35-3.16-0.88 c5.79,3.33,12.27,4.91,19.28,4.91c2.81,0,5.96-0.88,8.94-1.4c2.1-1.58,4.38-2.98,6.49-4.56l-4.21-2.45 C500.69,253.91,493.32,253.73,487.19,251.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M524.88,245.14L524.88,245.14c-0.35,0.18-0.7,0.35-1.05,0.53l1.23,0.7c5.26-2.81,10.34-5.26,15.43-7.19 c0.53-0.18,1.05-0.35,1.58-0.53c1.23-0.53,2.63-0.88,3.86-1.23c3.16-2.81,6.14-5.79,9.12-8.94c-2.1-1.05-4.03-1.93-5.96-2.81 C541.54,233.39,533.47,240.06,524.88,245.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M553.28,220.25c1.93,0.88,4.03,1.75,5.96,2.81c1.4-1.75,2.98-3.33,4.21-5.08c-2.1-1.05-4.03-1.93-6.14-2.98 C556.26,217.09,554.68,218.67,553.28,220.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M540.48,239c0.53-0.18,1.05-0.35,1.58-0.53C541.54,238.65,541.18,239,540.48,239z"
}), React.createElement("path", {
  className: "st1",
  d: "M555.21,228.13c1.4-1.58,2.8-3.33,4.21-5.08c-2.1-1.05-4.03-1.93-5.96-2.81c-1.4,1.75-2.8,3.51-4.21,5.08 C551,226.38,553.11,227.08,555.21,228.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M475.62,145.91c-7.19,12.45-12.27,25.42-15.43,38.22c3.51-12.97,8.94-26.12,15.78-38.04 c6.66-11.4,14.9-22.44,24.02-31.56C491.04,123.3,482.8,133.82,475.62,145.91z"
}), React.createElement("path", {
  className: "st1",
  d: "M458.09,194.82c0.18-0.7,0.35-1.58,0.35-2.28C458.26,193.42,458.09,194.12,458.09,194.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.1,106.29c-0.18,0.18-0.35,0.18-0.53,0.35C508.58,106.47,508.93,106.47,509.1,106.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M568.36,98.75c1.75,1.05,3.16,2.45,4.73,3.86c0.35-0.35,0.7-0.35,0.88-0.7c1.75-3.16,0.53-7.01-2.45-8.77l0,0 c-5.96-3.51-12.8-4.73-19.99-4.56C557.84,92.62,564.15,96.47,568.36,98.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M551.7,94.9c2.1,0,4.38,0,6.31,0.35C555.74,94.9,553.81,94.9,551.7,94.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.37,94.9c-14.55,1.05-29.45,9.99-42.78,23.32c6.14-5.96,12.62-11.22,19.28-15.08 C533.3,98.23,541.18,95.6,548.37,94.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M463.52,209.55c0-7.89,1.4-16.3,3.51-24.54c-4.38,16.3-5.26,32.26-0.7,44.88c0.18-0.18,0.35-0.18,0.53-0.35 C464.57,223.75,463.52,217.27,463.52,209.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M478.25,254.96c1.05,0.53,2.1,0.88,3.16,0.88c2.28,0,4.38-1.23,5.61-3.16c0.18-0.35,0-0.88,0.18-1.23 c-1.93-0.7-4.03-1.23-5.79-2.1l-11.22-6.49c-0.88,0.7-1.93,1.23-2.81,1.93C470.18,249,473.86,252.68,478.25,254.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M472.29,241.28c0.18,0.35,0.53,0.53,0.88,0.88c-0.18-0.35-0.35-0.7-0.7-1.05 C472.29,241.28,472.29,241.28,472.29,241.28z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.64,248.82c-2.8,1.23-5.43,2.1-8.06,2.81l4.21,2.45c1.58-1.05,3.16-2.28,4.73-3.33 c0.35-0.18,0.7-0.53,1.05-0.7L516.64,248.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.74,250.05c0.88-0.53,1.75-1.4,2.8-1.93c0.18,0,0.18-0.18,0.35-0.18c1.05-0.53,2.1-1.05,3.16-1.58 c0,0,0.18,0,0.18-0.18l-1.23-0.7c-2.45,1.4-4.73,2.28-7.19,3.33L518.74,250.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M463.52,239c0,0.18,0.18,0.18,0.18,0.35c0,0,0.18,0,0.18-0.18L463.52,239z"
}), React.createElement("path", {
  className: "st1",
  d: "M466.33,229.89c0.53,1.4,1.23,2.81,1.93,4.03c-0.53-1.4-0.88-2.98-1.4-4.38 C466.33,229.71,466.33,229.71,466.33,229.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M521.37,248.3c-0.88,0.53-1.75,1.4-2.8,1.93l0,0C519.62,249.52,520.5,248.82,521.37,248.3 c1.23-0.7,2.28-1.23,3.51-1.75c-1.05,0.53-2.1,1.05-3.16,1.58C521.55,247.95,521.55,247.95,521.37,248.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M470.18,242.86l-6.14-3.51c0,0-0.18,0-0.18,0.18c1.05,1.93,2.28,3.68,3.51,5.43 C468.08,244.09,468.95,243.56,470.18,242.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M469.66,236.73c0.88,1.58,1.58,3.33,2.63,4.73l0.18-0.18C471.41,239.71,470.36,238.48,469.66,236.73z"
}), React.createElement("path", {
  className: "st1",
  d: "M517.69,250.93c0.35-0.18,0.7-0.53,1.05-0.7l0,0C518.22,250.4,518.04,250.58,517.69,250.93z"
}), React.createElement("path", {
  className: "st1",
  d: "M521.55,97.7c-4.21,2.45-8.41,5.43-12.62,8.77c-0.18,0.18-0.35,0.18-0.53,0.35c-2.81,2.28-5.61,5.08-8.42,7.71 c-9.12,9.29-17.36,20.16-24.02,31.56c-6.84,11.92-12.27,25.07-15.78,38.04c-0.7,2.81-1.4,5.79-1.93,8.59 c-0.18,0.7-0.35,1.58-0.35,2.28c-0.7,5.08-1.23,9.99-1.23,14.73c0,9.12,1.58,16.83,4.21,23.84c1.58-1.23,3.33-2.45,5.08-3.51 c-4.56-12.62-3.68-28.4,0.7-44.88c2.98-12.27,7.89-24.54,14.55-36.11s15.08-21.91,24.19-30.86c13.32-13.32,28.23-22.26,42.78-23.32 c1.23-0.18,2.1,0,3.33,0c2.1,0,4.21,0,6.31,0.35c3.68,0.53,7.36,1.75,10.34,3.51c-4.38-2.45-10.34-6.31-17.01-10.34 C542.24,88.76,532.07,91.56,521.55,97.7z"
}), React.createElement("polygon", {
  className: "st1",
  points: "516.64,248.82 518.74,250.05 518.74,250.05 516.82,248.82  "
}), React.createElement("path", {
  className: "st1",
  d: "M472.99,242.34c-0.18-0.35-0.53-0.53-0.88-0.88c-0.7,0.53-1.58,1.05-2.28,1.58l11.22,6.49 C478.25,247.77,475.62,245.14,472.99,242.34z"
}), React.createElement("path", {
  className: "st1",
  d: "M468.95,235.67c-0.35-0.7-0.7-1.23-1.05-1.75c-0.7-1.4-1.4-2.63-1.93-4.03c-1.75,1.23-3.51,2.28-5.08,3.51 c0.7,1.93,1.4,3.86,2.45,5.61l0.53,0.18C465.62,238.3,467.38,236.9,468.95,235.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M469.66,236.73c-0.18-0.35-0.35-0.53-0.53-0.88c-1.75,1.23-3.51,2.28-5.08,3.68l6.14,3.51 c0.7-0.53,1.58-1.05,2.28-1.58C471.23,240.06,470.36,238.3,469.66,236.73z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.74,250.05L518.74,250.05L518.74,250.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M540.48,239c-5.08,1.93-10.17,4.38-15.43,7.19l0,0C530.14,243.91,535.22,241.28,540.48,239z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.24,238.48c1.23-0.53,2.45-0.7,3.86-1.23c0,0,0.18,0,0.18-0.18C544.69,237.78,543.29,237.95,542.24,238.48 z"
}), React.createElement("path", {
  className: "st1",
  d: "M512.78,254.26c-2.1,1.4-4.38,2.81-6.49,4.56h0.18C508.58,257.06,510.68,255.83,512.78,254.26L512.78,254.26z"
}), React.createElement("path", {
  className: "st1",
  d: "M540.48,239c-5.43,2.1-10.52,4.56-15.43,7.19l2.98,1.75c0.7,0.35,1.05,1.05,1.58,1.58 c5.61-3.33,10.87-7.54,16.13-12.27c-1.23,0.35-2.63,0.7-3.86,1.23C541.54,238.65,541.18,239,540.48,239z"
}), React.createElement("path", {
  className: "st1",
  d: "M506.47,258.81c3.16-0.53,6.31-1.4,9.47-2.63l-3.16-1.93C510.68,255.83,508.58,257.06,506.47,258.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M512.78,254.26c1.58-1.05,3.16-2.28,4.73-3.33C515.94,251.8,514.54,253.21,512.78,254.26L512.78,254.26z"
}), React.createElement("polygon", {
  className: "st1",
  points: "525.06,246.19 525.06,246.19 524.88,246.54  "
}), React.createElement("path", {
  className: "st1",
  d: "M518.74,250.05c-0.35,0.18-0.7,0.53-1.05,0.7c-1.58,1.05-3.16,2.28-4.73,3.33l3.16,1.93 c2.45-0.88,4.91-1.93,7.36-3.16L518.74,250.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M525.06,246.19c0,0-0.18,0-0.18,0.18c-1.05,0.53-2.1,1.05-3.33,1.75c-1.05,0.53-1.93,1.4-2.8,1.93l4.73,2.63 c1.58-0.7,3.16-1.23,4.73-2.1l0,0c0.53-0.35,1.05-0.7,1.58-1.05c-0.53-0.53-0.88-1.23-1.58-1.58L525.06,246.19z"
}), React.createElement("polygon", {
  className: "st1",
  points: "518.74,250.05 518.74,250.05 523.48,252.85 523.48,252.68  "
}), React.createElement("path", {
  className: "st1",
  d: "M554.33,101.56c0.7,0,1.4,0.18,2.1,0.18C555.56,101.56,555.21,101.56,554.33,101.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M470.01,209.55c0-4.03,0.35-8.24,1.05-12.45c-1.75,10.52-1.58,20.34,1.05,28.75c0.18,0,0.18-0.18,0.35-0.18 C470.71,220.95,470.01,215.86,470.01,209.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M471.23,194.65c0.35-2.1,1.05-4.38,1.58-6.49C472.29,190.27,471.76,192.55,471.23,194.65z"
}), React.createElement("path", {
  className: "st1",
  d: "M550.13,101.56c-10.52,0.35-21.56,5.61-32.08,14.03c3.33-2.63,6.66-4.91,9.99-6.84 C535.92,104.19,543.29,102.08,550.13,101.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M511.21,121.72c1.4-1.4,2.98-2.81,4.38-4.21C514.01,118.91,512.61,120.14,511.21,121.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M565.38,104.71L565.38,104.71c9.29,5.43,14.55,17.53,14.55,34.19c0,17.88-6.14,38.22-17.18,57.33 c-3.33,5.96-7.19,11.4-11.22,16.48c2.1,0.88,4.03,1.75,6.14,2.63c3.86-5.08,7.54-10.34,10.69-15.95 c11.04-19.28,18.06-41.02,18.06-60.66c0-16.66-5.08-28.58-13.32-35.94C570.99,104.89,568.18,105.94,565.38,104.71z"
}), React.createElement("path", {
  className: "st1",
  d: "M508.4,251.63l-8.42-4.91c-5.61,0.53-10.87-0.35-15.25-2.98l0,0c2.63,1.75,3.33,4.91,2.28,7.71 C493.32,253.73,500.69,253.91,508.4,251.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M522.08,239.53c0,0-0.18,0.18-0.35,0.18c-1.58,0.88-2.98,1.4-4.56,2.1l6.66,3.86c0.35-0.18,0.7-0.18,1.05-0.53 l0,0c8.59-4.91,16.83-11.75,24.19-19.81c-2.28-1.05-4.38-1.75-6.49-2.63C535.92,229.71,529.09,235.15,522.08,239.53L522.08,239.53z "
}), React.createElement("path", {
  className: "st1",
  d: "M472.29,225.86c-0.18,0-0.18,0.18-0.35,0.18c0.53,1.4,1.05,2.81,1.58,4.03 C472.99,228.66,472.46,227.08,472.29,225.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M547.32,217.62c2.1,0.7,4.03,1.58,6.14,2.63c1.4-1.75,2.8-3.33,4.21-5.08c-2.1-1.05-4.03-1.93-6.14-2.63 C549.95,214.29,548.72,216.04,547.32,217.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M477.72,237.43c-0.7-1.05-1.4-2.1-1.93-3.33C476.14,235.15,476.67,236.37,477.72,237.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.41,222.7c2.1,0.7,4.21,1.58,6.49,2.63c1.58-1.58,2.8-3.51,4.21-5.08c-2.1-1.05-4.21-1.75-6.14-2.63 C545.57,219.37,544.17,221.12,542.41,222.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M551.7,94.9c-1.05,0-2.28-0.18-3.33,0c-7.19,0.7-15.08,3.33-23.49,8.06c-6.84,3.86-13.15,9.29-19.28,15.08 c-17.71,17.71-32.08,42.6-38.74,66.8c-2.1,8.42-3.51,16.66-3.51,24.54c0,7.71,1.4,14.2,3.33,19.99c1.75-1.23,3.51-2.45,5.26-3.68 c-2.63-8.42-2.63-18.23-1.05-28.75c0.18-0.88,0.18-1.58,0.35-2.45c0.35-2.1,0.88-4.38,1.58-6.49c2.81-11.92,7.36-24.19,14.2-35.94 c6.84-11.92,15.25-22.26,24.37-30.68c1.4-1.4,2.98-2.81,4.38-4.21c0.88-0.7,1.58-1.23,2.45-1.93 c10.52-8.42,21.39-13.67,32.08-14.03c0.7,0,1.4-0.35,2.1-0.35s1.4,0.18,1.93,0.18c0.7,0,1.4,0.18,2.1,0.18 c3.16,0.53,6.14,1.23,8.59,2.81l0,0h0.18c2.63,1.4,5.79,0.35,7.71-1.93c-1.58-1.4-2.98-2.81-4.73-3.86 c-3.33-1.75-6.84-2.81-10.34-3.51C555.74,94.9,553.81,94.9,551.7,94.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.82,248.82c2.45-1.05,4.73-1.93,7.19-3.33l-6.66-3.86c-2.45,1.23-5.08,2.45-7.54,3.16L516.82,248.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M484.91,243.91L484.91,243.91c-0.18-0.18-0.18-0.18-0.18-0.18c-2.63-1.58-4.91-3.68-6.84-6.31 c-1.75,1.23-3.51,2.45-5.26,3.68c0.18,0.35,0.35,0.7,0.7,1.05c2.28,2.81,4.91,5.26,8.24,7.36c1.75,1.05,3.86,1.58,5.79,2.1 C488.24,248.82,487.54,245.67,484.91,243.91z"
}), React.createElement("path", {
  className: "st1",
  d: "M500.16,246.72l8.42,4.91c2.63-0.7,5.26-1.58,8.06-2.81l-7.01-4.03C506.3,246.02,502.97,246.72,500.16,246.72z "
}), React.createElement("path", {
  className: "st1",
  d: "M474.39,231.99c-0.35-0.7-0.7-1.23-0.88-1.93c-0.53-1.4-1.23-2.63-1.58-4.03c-1.75,1.23-3.51,2.45-5.26,3.68 c0.53,1.4,0.88,3.16,1.4,4.38c0.35,0.7,0.7,1.23,1.05,1.75C470.71,234.62,472.46,233.39,474.39,231.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M477.72,237.43L477.72,237.43c-0.88-1.23-1.4-2.28-2.1-3.51c-0.35-0.7-0.88-1.4-1.23-2.1 c-1.75,1.23-3.51,2.45-5.26,3.68c0.18,0.35,0.35,0.7,0.53,0.88c0.88,1.58,1.93,3.16,2.98,4.56 C474.39,240.06,475.79,238.65,477.72,237.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M505.42,118.39c-9.12,8.77-17.53,19.28-24.19,30.86c-6.66,11.4-11.4,23.84-14.55,36.11 C473.34,160.81,487.71,136.09,505.42,118.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M568.36,98.75c-3.16-1.75-6.66-2.81-10.34-3.51C561.52,95.95,565.03,97.17,568.36,98.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.37,94.9c1.05,0,2.28,0,3.33,0C550.3,94.9,549.25,94.9,548.37,94.9z"
}), React.createElement("polygon", {
  className: "st1",
  points: "509.63,244.97 509.63,244.97 516.64,248.82 516.82,248.82  "
}), React.createElement("path", {
  className: "st1",
  d: "M481.23,249.52c-3.16-2.1-5.96-4.56-8.24-7.36C475.62,245.14,478.25,247.77,481.23,249.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M467.9,234.1c0.35,0.7,0.7,1.23,1.05,1.75l0,0C468.6,235.15,468.43,234.62,467.9,234.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M468.95,235.67L468.95,235.67c0.18,0.35,0.35,0.53,0.53,0.88C469.48,236.37,469.13,236.2,468.95,235.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M529.26,404.33c0-3.51-2.8-6.49-6.49-6.49c-3.51,0-6.49,2.98-6.49,6.49v52.59l12.97-7.54V404.33z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.29,520.39c0,3.68,2.98,6.49,6.49,6.49s6.49-2.8,6.49-6.49v-56.28l-12.97,7.54 C516.29,471.82,516.29,520.39,516.29,520.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.99,674.66c3.51,0,6.49-2.98,6.49-6.49v-56.1L516.29,472v-14.9L263.84,602.78 c-2.1,1.23-3.33,3.33-3.33,5.61v59.78C260.5,671.51,263.66,674.66,266.99,674.66z"
}), React.createElement("path", {
  className: "st1",
  d: "M772.25,324.03v49.09c0,3.51,2.98,6.49,6.49,6.49s6.49-2.98,6.49-6.49v-60.31c0-2.28-1.23-4.38-3.16-5.61 c-1.93-1.23-4.56-1.23-6.49,0L529.44,449.21v14.9L772.25,324.03z"
}), React.createElement("polygon", {
  className: "st1",
  points: "529.26,464.28 529.26,449.38 516.29,456.92 516.29,471.82  "
}), React.createElement("path", {
  className: "st0",
  d: "M240.69,840.34l-8.24-4.73c-28.58,23.49-49.61,61.54-53.65,98.7l18.23,10.52c0.18-0.7,0.35-1.4,0.53-2.28 c0.53-3.68,1.4-7.19,2.28-11.04c0.53-2.1,1.05-4.21,1.58-6.49c0.88-2.8,1.75-5.61,2.81-8.41c1.23-3.51,2.45-6.84,3.86-10.34 c0.7-1.4,1.23-2.98,1.93-4.38c2.1-4.56,4.38-9.12,6.84-13.5c0.18-0.35,0.35-0.7,0.53-1.05c0.18-0.35,0.35-0.53,0.53-0.88 c2.98-5.08,6.14-9.99,9.64-14.55c0.7-1.05,1.4-1.93,2.1-2.98c2.63-3.51,5.43-6.84,8.42-9.99c1.58-1.93,3.33-3.86,4.91-5.61 c1.23-1.4,2.81-2.45,4.03-3.68c2.1-2.1,4.21-4.21,6.49-5.96C248.93,843.67,244.55,842.44,240.69,840.34z"
}), React.createElement("path", {
  className: "st1",
  d: "M306.26,821.75c7.54,0.18,14.9,1.58,21.21,5.08c-2.63-1.58-5.61-3.33-8.77-5.26 c-4.91-2.98-10.17-6.14-15.25-8.94c-1.23,1.75-2.63,3.51-4.03,5.26C301.35,819.12,303.63,820.35,306.26,821.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M196.34,951.84l-24.37-14.03c2.98-39.09,24.02-79.77,54.7-105.72l-5.96-3.33 c-30.68,26.82-52.24,67.85-55.22,108.52c-0.18,2.45,1.05,4.91,3.33,6.14l30.33,17.53c-2.1-1.23-3.16-3.51-3.16-5.79 C196.16,954.12,196.16,952.89,196.34,951.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M199.14,960.78c1.05,0.53,2.1,0.88,3.16,0.88C201.25,961.83,200.02,961.66,199.14,960.78L199.14,960.78z"
}), React.createElement("path", {
  className: "st1",
  d: "M205.46,960.95C205.63,960.95,205.63,960.95,205.46,960.95c-0.88,0.53-1.93,0.7-2.98,0.7 C203.35,961.83,204.4,961.66,205.46,960.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M208.26,906.43c-1.4,3.33-2.81,6.84-3.86,10.34C205.46,913.44,206.68,909.76,208.26,906.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M306.26,821.75c-2.45-1.4-4.73-2.63-7.19-4.03c-1.4,1.75-2.81,3.51-4.21,5.08 C298.72,821.93,302.41,821.75,306.26,821.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M243.32,853.48c1.4-1.4,2.81-2.45,4.03-3.68C245.95,851.21,244.38,852.43,243.32,853.48z"
}), React.createElement("path", {
  className: "st1",
  d: "M197.22,944.65l-18.23-10.52c4.03-37.17,25.07-75.21,53.65-98.7l-5.79-3.33 c-30.5,25.95-51.72,66.62-54.7,105.72l24.37,14.03c0.18-2.98,0.7-6.14,1.23-9.29C197.39,943.25,197.22,944.12,197.22,944.65z"
}), React.createElement("path", {
  className: "st1",
  d: "M217.03,888.55c-2.45,4.38-4.73,8.94-6.84,13.5C212.12,897.49,214.4,892.93,217.03,888.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.6,925.36c-0.53,2.1-1.05,4.21-1.58,6.49C200.2,929.4,200.72,927.29,201.6,925.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.24,859.09c-2.98,3.16-5.79,6.49-8.42,9.99C232.45,865.58,235.26,862.25,238.24,859.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M227.55,872.07c-3.51,4.73-6.66,9.64-9.64,14.55C221.06,881.71,224.21,876.63,227.55,872.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M225.27,806.5c0-2.28,0.18-4.73,0.53-7.01c0.35-2.45,0.7-4.91,1.23-7.54c0.18-1.05,0.53-2.1,0.7-3.33 c2.28-8.59,5.61-17.36,10.52-25.95c4.91-8.59,11.04-16.13,17.53-22.44c0.7-0.7,1.23-1.23,1.93-1.75c2.1-1.93,4.21-3.68,6.49-5.26 c1.75-1.4,3.68-2.63,5.61-3.86c0.18-0.18,0.35-0.35,0.53-0.35c0.53-0.35,1.05-0.35,1.58-0.7c2.28-1.23,4.56-2.8,7.01-3.68 c-5.96-3.33-11.92-6.31-14.73-6.66c-0.88-0.18-1.75-0.18-2.63-0.18c-19.46,0-41.2,25.6-49.97,50.84 c-5.43,15.78-7.01,35.24,5.26,42.78l8.77,5.08c-0.35-2.28-0.18-4.91-0.35-7.36c0-0.7-0.18-1.23-0.18-1.75 C225.27,807.38,225.27,807.03,225.27,806.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M213.34,817.2c-34.89-21.21,9.99-110.45,51.54-105.36c5.08,0.7,14.73,5.96,23.49,11.22 c6.49-0.7,12.8,0.18,18.06,3.33c-1.93-1.23-4.56-2.63-7.36-4.38c-14.55-8.77-26.12-15.78-33.49-16.66 c-27.88-3.51-55.22,27.52-66.27,59.26c-9.29,26.65-5.26,48.39,10.87,58.03l10.52,6.14c1.75-1.58,3.33-3.16,5.08-4.56L213.34,817.2z "
}), React.createElement("path", {
  className: "st1",
  d: "M233.68,834.55c-0.35,0.35-0.88,0.7-1.23,1.05l8.24,4.73C237.89,838.58,235.61,836.83,233.68,834.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M230.18,829.12c-0.53-1.05-1.05-2.1-1.58-3.33l-2.81-1.58c-1.75,1.4-3.33,2.98-5.08,4.56l5.96,3.33 C227.9,831.22,229.12,830.17,230.18,829.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M233.68,834.55c-1.4-1.58-2.45-3.51-3.51-5.43c-1.23,1.05-2.45,2.1-3.68,2.98l5.79,3.33 C232.98,835.08,233.33,834.9,233.68,834.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.62,729.54c-1.93,1.23-3.68,2.45-5.61,3.86C265.94,731.99,268.04,730.76,269.62,729.54z"
}), React.createElement("path", {
  className: "st1",
  d: "M227.9,788.79c-0.35,1.05-0.53,2.28-0.7,3.33C227.37,791.07,227.55,789.85,227.9,788.79z"
}), React.createElement("path", {
  className: "st1",
  d: "M225.27,809.31c0,2.45-0.18,4.91,0.35,7.36l-8.77-5.08c-12.27-7.36-10.69-27-5.26-42.78 c8.77-25.42,30.5-50.84,49.97-50.84c0.88,0,1.75,0,2.63,0.18c2.98,0.35,8.77,3.33,14.73,6.66c-2.45,0.88-4.73,2.45-7.01,3.68 c5.61-3.16,11.22-4.91,16.66-5.61c-8.94-5.26-18.41-10.69-23.49-11.22c-41.37-5.08-86.43,84.33-51.54,105.36l12.45,7.19 c0.53-0.53,1.23-0.88,1.93-1.23C226.32,818.77,225.44,814.21,225.27,809.31z"
}), React.createElement("path", {
  className: "st1",
  d: "M225.27,806.5c0-2.28,0.35-4.73,0.53-7.01C225.44,801.94,225.27,804.22,225.27,806.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M255.95,740.41c0.7-0.7,1.23-1.23,1.93-1.75C257.17,739.36,256.47,739.71,255.95,740.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M225.79,824.03l2.81,1.58c-0.35-0.88-0.7-1.93-0.88-2.98C227.02,823.51,226.32,823.86,225.79,824.03z"
}), React.createElement("path", {
  className: "st0",
  d: "M320.99,838.06c-2.98-1.58-5.96-2.45-8.94-3.16c-0.7-0.18-1.4-0.18-2.1-0.18c-2.1-0.35-4.21-0.35-6.31-0.18 c-2.63,0.18-5.61,0.7-8.42,1.4c-1.58,0.35-2.98,0.53-4.56,1.05c-4.38,1.4-8.94,3.33-13.67,6.14 c-13.67,8.24-26.12,19.99-36.47,33.48c-0.18,0.18-0.18,0.18-0.35,0.35c-1.93,2.45-3.51,5.26-5.26,7.89 c-1.75,2.63-3.51,5.08-5.08,7.71c-5.61,9.47-10.34,19.46-13.85,29.8c-0.18,0.35-0.18,0.7-0.35,1.05 c-2.1,6.49-3.68,13.15-4.91,19.64l127.28-73.46C336.42,854.54,330.1,843.67,320.99,838.06z"
}), React.createElement("path", {
  className: "st0",
  d: "M320.99,838.06c-2.63-1.58-5.79-2.45-8.94-3.16C315.03,835.78,317.83,836.66,320.99,838.06L320.99,838.06z"
}), React.createElement("path", {
  className: "st0",
  d: "M276.81,843.14c-13.15,7.54-25.6,19.28-36.47,33.48C250.86,863.13,263.13,851.38,276.81,843.14z"
}), React.createElement("path", {
  className: "st0",
  d: "M210.36,943.25l0.35-0.18c1.23-6.66,2.63-13.15,4.91-19.64C213.17,930.1,211.59,936.76,210.36,943.25z"
}), React.createElement("path", {
  className: "st0",
  d: "M228.95,893.98c-5.26,9.29-9.64,18.76-12.8,28.4c3.51-10.34,8.24-20.34,13.85-29.8 C229.47,892.93,229.12,893.63,228.95,893.98z"
}), React.createElement("path", {
  className: "st0",
  d: "M305.39,834.02c-0.53,0-1.4,0.35-1.93,0.35c2.1-0.18,4.21,0,6.31,0.18 C308.54,834.55,306.96,834.02,305.39,834.02z"
}), React.createElement("path", {
  className: "st0",
  d: "M234.73,885.04c1.75-2.63,3.51-5.26,5.26-7.89C238.24,879.61,236.66,882.06,234.73,885.04z"
}), React.createElement("path", {
  className: "st0",
  d: "M290.48,837.01c1.58-0.53,3.16-0.7,4.56-1.05C293.64,836.13,292.06,836.3,290.48,837.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M327.12,827.01c3.16,1.75,4.21,5.61,2.45,8.77c-0.18,0.35-0.7,0.35-0.88,0.7c8.94,7.54,14.9,19.99,15.95,36.82 l-135.17,78.02c-0.18,1.58-0.53,3.16-0.7,4.73c-0.18,2.28-1.4,4.03-3.33,5.08c0,0,0,0,0.18,0l142.36-82.22 c2.1-1.23,3.33-3.51,3.16-5.96C350.09,851.21,341.5,834.9,327.12,827.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M198.97,960.78L198.97,960.78L198.97,960.78z"
}), React.createElement("path", {
  className: "st1",
  d: "M217.03,888.55c0.35-0.7,0.7-1.23,1.05-1.93c-0.18,0.35-0.35,0.53-0.53,0.88 C217.2,887.85,217.2,888.37,217.03,888.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M199.67,931.5c-0.88,3.68-1.75,7.36-2.28,11.04C198.27,938.86,198.97,935.36,199.67,931.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M204.05,916.95c-1.05,2.8-1.93,5.61-2.81,8.41C202.3,922.38,203.35,919.58,204.05,916.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M210.01,902.05c-0.7,1.4-1.4,2.98-1.93,4.38C208.79,905.03,209.31,903.63,210.01,902.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M247.18,849.98c2.28-2.1,4.38-4.03,6.66-5.96h-0.18C251.56,845.77,249.46,847.88,247.18,849.98z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.24,859.09c1.75-1.93,3.33-3.86,4.91-5.61C241.57,855.41,239.99,857.17,238.24,859.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M229.65,869.09c-0.7,0.88-1.4,1.93-2.1,2.98C228.42,871.02,229.12,869.96,229.65,869.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M302.05,828.06c3.51-0.18,6.84,0,10.17,0.53C308.72,827.89,305.39,827.89,302.05,828.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.97,832.62c-2.98-1.58-5.96-2.63-8.77-3.33C318.36,829.82,321.34,830.87,323.97,832.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M208.79,955.69c0.18-1.58,0.53-3.16,0.7-4.73l-7.19,4.21l-5.96-3.51c0,1.05-0.35,2.1-0.35,3.16 c-0.18,2.45,1.05,4.56,3.16,5.79l0,0c1.05,0.7,2.28,1.05,3.33,1.05s2.1-0.35,3.16-0.88C207.38,959.73,208.79,957.97,208.79,955.69z "
}), React.createElement("path", {
  className: "st1",
  d: "M282.42,833.5c1.58-0.7,2.98-1.58,4.56-2.1c-1.23,0.53-2.45,0.88-3.51,1.4 C282.94,832.97,282.77,833.32,282.42,833.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M300.83,828.24c-3.86,0.35-7.71,1.23-11.4,2.45C293.29,829.29,296.97,828.41,300.83,828.24z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.97,832.62c1.75,1.05,3.16,2.45,4.73,3.86c0.18-0.35,0.7-0.35,0.88-0.7c1.58-3.16,0.53-7.01-2.45-8.77 c-6.31-3.68-13.5-5.08-21.21-5.08C312.4,825.61,318.88,829.47,323.97,832.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M211.94,914.85c-0.88,2.1-1.75,4.21-2.45,6.31C210.01,919.23,211.07,917.12,211.94,914.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M242.97,863.3c-7.36,8.24-14.03,17.36-19.64,27C229.12,880.66,235.78,871.37,242.97,863.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M222.11,892.76c-2.45,4.38-4.73,8.59-6.66,13.15C217.55,901.52,219.83,897.14,222.11,892.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M294.87,822.8c-3.51,3.86-7.36,7.01-11.4,9.99c1.23-0.53,2.45-1.05,3.51-1.4c0.7-0.35,1.4-0.53,2.28-0.7 c3.86-1.23,7.54-2.1,11.4-2.45c0.53,0,1.05,0,1.58-0.18c3.33-0.18,6.66-0.18,10.17,0.53c1.05,0.18,1.93,0.53,2.98,0.7 c2.98,0.7,5.96,1.75,8.77,3.33c-5.26-2.98-11.57-7.01-17.88-10.87C302.41,821.75,298.72,821.93,294.87,822.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M211.94,914.85c1.23-2.98,2.28-6.14,3.68-9.12c1.93-4.56,4.38-8.77,6.66-13.15c0.35-0.7,0.7-1.4,1.05-1.93 c0-0.18,0.18-0.18,0.18-0.18c5.61-9.82,12.27-18.76,19.64-27c8.06-9.12,16.66-16.66,25.77-22.62c-4.91,1.93-9.64,3.16-14.03,3.16 c-0.35,0-0.53-0.18-0.88-0.18c-2.28,1.93-4.56,3.86-6.66,5.96c-1.4,1.23-2.81,2.45-4.03,3.68c-1.75,1.75-3.33,3.68-4.91,5.61 c-2.81,3.16-5.79,6.49-8.42,9.99c-0.7,0.88-1.4,1.93-2.1,2.98c-3.33,4.73-6.66,9.47-9.64,14.55c-0.35,0.7-0.7,1.23-1.05,1.93 c-2.45,4.38-4.73,8.94-6.84,13.5c-0.7,1.4-1.4,2.98-1.93,4.38c-1.4,3.51-2.81,6.84-3.86,10.34c-1.05,2.8-1.93,5.61-2.81,8.41 c-0.7,2.1-1.05,4.21-1.58,6.49c-0.88,3.68-1.75,7.36-2.28,11.04c-0.53,3.16-0.88,6.14-1.23,9.29l5.96,3.51 c0.7-11.04,3.16-22.44,7.01-33.84C210.01,919.23,211.07,917.12,211.94,914.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M276.81,843.14c4.73-2.63,9.12-4.56,13.67-6.14C286.1,838.41,281.72,840.34,276.81,843.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M229.65,892.58c1.58-2.63,3.33-5.08,5.08-7.71C232.98,887.5,231.23,889.78,229.65,892.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M215.45,923.44c0.18-0.35,0.18-0.7,0.35-1.05C215.97,922.56,215.8,922.91,215.45,923.44z"
}), React.createElement("path", {
  className: "st1",
  d: "M239.99,877.15c0.18-0.18,0.18-0.18,0.35-0.35C240.17,876.63,240.17,876.8,239.99,877.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M309.77,834.73c0.7,0.18,1.4,0.18,2.1,0.18C311.17,834.9,310.64,834.9,309.77,834.73z"
}), React.createElement("path", {
  className: "st1",
  d: "M321.16,838.06h-0.18c9.47,5.43,15.43,16.48,17.01,31.38L210.71,942.9c-0.53,2.63-0.88,5.43-1.23,8.06 l135.17-78.02c-1.05-16.83-7.01-29.28-15.95-36.82C327.12,838.58,323.79,839.46,321.16,838.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M295.04,835.95c2.98-0.7,5.79-1.23,8.42-1.4C300.83,834.73,298.02,835.08,295.04,835.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.2,829.29c-1.05-0.18-1.93-0.53-2.98-0.7c-3.16-0.53-6.49-0.7-10.17-0.53c-0.53,0-1.05,0-1.58,0.18 c-3.68,0.35-7.54,1.23-11.4,2.45c-0.7,0.18-1.58,0.53-2.28,0.7c-1.4,0.53-2.98,1.4-4.56,2.1c-1.93,1.4-3.68,2.8-5.61,3.86 c-2.63,1.58-5.26,2.45-7.89,3.51c-9.47,6.31-18.06,14.03-25.95,22.62c-7.19,8.06-13.85,17.18-19.64,27 c-0.35,0.7-0.7,1.58-1.23,2.28c-2.45,4.38-4.73,8.77-6.66,13.15c-1.4,2.98-2.45,6.14-3.68,9.12c-0.88,2.1-1.75,4.21-2.45,6.31 c-3.68,11.22-6.14,22.62-7.01,33.84l7.19-4.21c0.35-2.63,0.7-5.43,1.23-8.06l-0.35,0.18c1.05-6.49,2.98-13.15,5.26-19.99 c0.18-0.35,0.18-0.7,0.35-1.05c3.33-9.47,7.54-19.11,12.8-28.4c0.35-0.53,0.7-0.88,0.88-1.4c1.58-2.63,3.33-5.08,5.08-7.71 c1.75-2.63,3.51-5.43,5.26-7.89c0.18-0.18,0.18-0.18,0.35-0.35c10.87-14.38,23.32-25.95,36.47-33.48 c4.91-2.63,9.29-4.56,13.67-6.14c1.58-0.53,3.16-0.7,4.56-1.05c2.98-0.7,5.79-1.23,8.42-1.4c0.7,0,1.4-0.35,1.93-0.35 c1.58,0,2.98,0.35,4.38,0.53c0.7,0.18,1.4,0.18,2.1,0.18c3.16,0.7,6.14,1.58,8.94,3.16l0,0h0.18c2.81,1.4,5.96,0.35,7.89-1.93 c-1.58-1.4-2.98-2.8-4.73-3.86C321.34,830.87,318.36,829.82,315.2,829.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M242.97,863.3c7.89-8.77,16.48-16.3,25.95-22.62h-0.18C259.8,846.82,251.04,854.36,242.97,863.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M215.45,905.9c-1.4,2.98-2.45,6.14-3.68,9.12C212.82,911.86,214.22,908.71,215.45,905.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.2,829.29c-1.05-0.18-1.93-0.53-2.98-0.7C313.1,828.59,314.15,828.94,315.2,829.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M289.26,830.52c-0.7,0.18-1.4,0.53-2.28,0.7C287.68,831.22,288.38,830.69,289.26,830.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M222.11,892.76c0.35-0.7,0.7-1.58,1.23-2.28c0,0.18-0.18,0.18-0.18,0.18 C222.64,891.53,222.46,892.05,222.11,892.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M300.83,828.24c0.53,0,1.05,0,1.58-0.18C301.53,828.06,301,828.06,300.83,828.24z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.3,955.34c0.88-11.22,3.33-22.79,7.01-33.84C205.63,932.73,203.18,944.3,202.3,955.34z"
}), React.createElement("path", {
  className: "st1",
  d: "M309.07,734.97c-0.18,0.35-0.7,0.53-0.88,0.7c4.73,5.08,7.54,12.97,7.54,23.32c0,16.66-7.19,35.41-18.23,50.49 c1.93,0.88,3.86,1.93,5.79,2.98c11.57-15.95,18.93-35.76,18.93-53.65c0-15.25-5.43-27-15.6-32.78 C309.59,728.13,310.64,731.82,309.07,734.97z"
}), React.createElement("path", {
  className: "st1",
  d: "M249.46,836.83c-0.18,0.35,0,0.88-0.18,1.23c-1.23,2.1-3.33,3.16-5.43,3.16c-1.05,0-2.28-0.35-3.33-0.88 c4.03,2.28,8.42,3.33,13.15,3.51c3.68-3.16,7.36-5.61,11.22-8.24C259.28,837.36,254.19,837.88,249.46,836.83z"
}), React.createElement("path", {
  className: "st1",
  d: "M283.82,825.79c1.93-0.7,3.68-1.23,5.61-1.75c1.58-0.53,3.16-1.23,4.91-1.58c-1.93-1.05-3.86-1.75-5.79-2.63 c-2.63,2.8-5.43,5.26-8.42,7.36C281.19,826.49,282.42,826.14,283.82,825.79z"
}), React.createElement("path", {
  className: "st1",
  d: "M293.11,814.74c1.93,0.88,4.03,1.93,5.96,2.98c1.4-1.75,2.81-3.33,4.03-5.26c-1.93-1.05-3.86-2.1-5.79-2.98 C295.92,811.41,294.34,812.99,293.11,814.74z"
}), React.createElement("path", {
  className: "st1",
  d: "M278.91,828.06c1.58-0.7,3.16-1.58,4.73-2.28c-1.23,0.53-2.45,0.88-3.68,1.4 C279.61,827.36,279.44,827.54,278.91,828.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M288.38,819.65c1.93,0.88,3.68,1.58,5.79,2.63c-1.75,0.35-3.16,1.05-4.91,1.58c1.75-0.53,3.68-0.88,5.43-1.23 c1.4-1.58,2.81-3.33,4.21-5.08c-2.1-1.05-4.03-2.1-5.96-2.98C291.54,816.32,289.96,818.25,288.38,819.65z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.62,729.54c0.7-0.35,1.4-0.7,2.1-1.05c-0.53,0.35-1.05,0.35-1.58,0.7 C270.15,729.36,270.15,729.54,269.62,729.54z"
}), React.createElement("path", {
  className: "st1",
  d: "M225.27,807.38c0,0.7,0.18,1.23,0.18,1.75c0-0.88-0.18-1.75-0.18-2.63 C225.27,807.03,225.27,807.38,225.27,807.38z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.19,733.22c-2.1,1.58-4.38,3.33-6.49,5.26C259.8,736.55,261.91,735.15,264.19,733.22z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.42,762.85c-4.91,8.41-8.24,17.18-10.52,25.95c2.45-8.94,6.14-17.71,10.87-25.77 c4.73-8.24,10.69-15.95,17.36-22.44C249.46,746.72,243.32,754.08,238.42,762.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M227.02,792.12c-0.53,2.45-1.05,5.08-1.23,7.54C225.97,797.21,226.32,794.58,227.02,792.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M231.75,807.38c0-5.26,0.88-10.69,2.28-16.13c-2.63,9.99-3.16,19.64-0.88,27.7c0,0,0.18,0,0.18-0.18 C232.28,815.44,231.75,811.76,231.75,807.38z"
}), React.createElement("path", {
  className: "st1",
  d: "M291.71,729.36c1.58,0,2.98,0,4.38,0.18C294.87,729.19,293.29,729.36,291.71,729.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M288.38,723.05c5.79,3.33,11.22,6.84,14.9,8.94c1.75,1.05,3.33,2.28,4.73,3.86c0.35-0.35,0.7-0.35,0.88-0.7 c1.58-2.98,0.53-7.01-2.45-8.77C301,723.05,294.87,722,288.38,723.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M289.43,729.36c-9.82,0.7-19.99,6.66-28.93,15.6c4.03-3.86,8.42-7.54,12.97-10.17 C279.09,731.64,284.52,729.71,289.43,729.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M240.69,840.34c1.05,0.53,2.1,0.88,3.33,0.88c2.28,0,4.21-1.05,5.43-3.16c0.18-0.35,0-0.88,0.18-1.23 c-2.1-0.53-4.03-1.05-5.61-2.1l-5.79-3.33c-1.4,1.05-2.98,1.93-4.38,3.16C235.61,836.83,237.89,838.58,240.69,840.34z"
}), React.createElement("path", {
  className: "st1",
  d: "M232.98,819.3c0.53,1.75,1.05,3.33,1.75,4.91c-0.7-1.58-1.05-3.16-1.58-4.91 C232.98,819.12,232.98,819.12,232.98,819.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M228.6,825.96c0.53,1.23,1.05,2.28,1.58,3.33c0.53-0.53,1.23-0.88,1.75-1.23L228.6,825.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.42,829.64c-0.88-1.05-1.58-2.28-2.28-3.51C236.66,827.36,237.36,828.59,238.42,829.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.24,831.4l-6.14-3.51c-0.53,0.53-1.23,0.88-1.75,1.23c1.05,1.93,2.1,3.86,3.51,5.43 C235.08,833.32,236.66,832.45,238.24,831.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.62,729.54c-1.93,1.05-3.68,2.45-5.61,3.86c-2.1,1.58-4.38,3.33-6.49,5.26c-0.7,0.53-1.23,1.23-1.93,1.75 c-6.66,6.49-12.62,14.38-17.36,22.44s-8.42,17.01-10.87,25.77c-0.35,1.05-0.53,2.28-0.7,3.33c-0.53,2.45-0.88,5.08-1.23,7.54 s-0.53,4.73-0.53,7.01c0,0.88,0,1.75,0.18,2.63c0.18,5.08,1.05,9.47,2.28,13.68c1.75-1.4,3.51-2.45,5.26-3.68 c-2.28-8.06-1.75-17.71,0.88-27.7c2.1-8.59,5.43-17.18,10.17-25.25c4.56-8.06,10.34-15.25,16.66-21.21 c8.94-8.94,19.11-14.9,28.93-15.6c0.7,0,1.58,0,2.28,0c1.4,0,2.98,0,4.38,0.18c2.63,0.35,4.91,1.23,7.19,2.45 c-3.68-2.1-9.12-5.61-14.9-8.94c-5.26,0.7-10.87,2.45-16.66,5.61C271.2,728.66,270.32,729.19,269.62,729.54z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.94,830.52c-0.35,0.18-0.7,0.35-0.88,0.7l5.79,3.33C242.27,833.67,240.69,832.27,238.94,830.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M235.61,825.26c-0.18-0.53-0.53-0.88-0.7-1.4c-0.7-1.58-1.23-3.16-1.75-4.91c-1.75,1.23-3.51,2.45-5.26,3.68 c0.35,1.05,0.53,1.93,0.88,2.98l3.51,1.93C233.33,827.01,234.21,826.14,235.61,825.26z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.42,829.64c-0.88-1.05-1.58-2.28-2.28-3.51c-0.18-0.35-0.35-0.53-0.53-0.88 c-1.23,0.88-2.28,1.58-3.51,2.45l6.14,3.51c0.35-0.18,0.7-0.35,0.88-0.7C238.94,830.34,238.42,829.82,238.42,829.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M289.26,823.86c-1.93,0.53-3.68,1.05-5.61,1.75C285.57,824.91,287.33,824.56,289.26,823.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.89,835.6c-3.86,2.45-7.54,5.08-11.22,8.24h0.18C257.52,840.69,261.38,838.06,264.89,835.6 C265.24,835.6,264.89,835.6,264.89,835.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M273.48,837.36c-0.7,0.35-1.23,0.88-1.93,1.4C272.43,838.41,272.95,837.88,273.48,837.36 c2.98-1.75,5.96-2.8,8.77-4.03c0.35-0.18,0.7-0.35,0.88-0.7C280.14,834.02,276.81,835.78,273.48,837.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M273.48,837.36c3.16-1.75,6.49-3.33,9.82-4.73c4.03-2.98,7.89-6.14,11.4-9.99c-1.75,0.35-3.68,0.7-5.43,1.23 c-1.93,0.53-3.86,1.05-5.61,1.75c-1.58,0.53-3.16,1.4-4.73,2.28c-1.75,1.23-3.51,2.63-5.43,3.68c-2.98,1.75-5.79,2.98-8.59,3.86 c-3.86,2.63-7.54,5.26-11.04,8.24c0.35,0,0.53,0.18,0.88,0.18c4.38,0,9.12-1.23,14.03-3.16c0.88-0.7,1.93-1.4,2.81-1.93 C272.43,838.41,272.95,838.06,273.48,837.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M271.72,838.93c-0.88,0.53-1.75,1.23-2.63,1.93c2.63-1.05,5.26-1.93,7.89-3.51c1.93-1.05,3.68-2.45,5.61-3.86 c-2.98,1.23-5.79,2.28-8.77,4.03C272.95,837.88,272.43,838.41,271.72,838.93z"
}), React.createElement("path", {
  className: "st1",
  d: "M268.74,840.69h0.18c0.88-0.53,1.75-1.23,2.63-1.93C270.67,839.28,269.62,840.34,268.74,840.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.94,797.56c0.18-1.4,0.7-2.98,1.05-4.56C239.47,794.58,239.47,796.16,238.94,797.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M300.3,737.43L300.3,737.43c5.61,3.33,8.77,11.04,8.77,21.39c0,15.78-7.19,33.84-17.88,47.86 c1.93,0.7,4.03,1.75,5.96,2.63c11.04-15.08,18.23-33.84,18.23-50.49c0-10.34-2.81-18.23-7.54-23.32 C305.91,738.13,303.11,738.83,300.3,737.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.89,749.52c1.4-1.23,2.63-2.63,4.03-3.86C267.52,747.07,266.29,748.3,264.89,749.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M292.76,735.5c2.28,0,4.38,0.7,6.31,1.58C296.97,736.2,294.87,735.85,292.76,735.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.24,807.38c0-2.8,0.35-5.61,0.7-8.41c-1.05,5.79-1.05,11.22-0.18,16.13c0,0,0,0,0.18,0 C238.42,812.81,238.24,810.36,238.24,807.38z"
}), React.createElement("path", {
  className: "st1",
  d: "M291.01,735.85c-7.01,0.18-14.55,3.86-21.56,9.64c2.45-1.93,4.91-3.68,7.36-5.08 C282.07,737.25,286.63,736.02,291.01,735.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M247.18,829.12l-0.18-0.18C247.18,829.12,247.18,829.12,247.18,829.12c2.81,1.75,3.51,4.91,2.45,7.71 c4.56,1.05,9.82,0.7,15.43-1.23c1.58-1.05,2.98-2.28,4.56-3.16c0.18-0.18,0.35-0.35,0.7-0.53c0.18,0,0.18-0.18,0.18-0.18 c2.98-1.58,6.31-3.16,9.64-4.73c2.98-2.28,5.79-4.73,8.42-7.36c-2.45-1.05-4.73-1.75-7.01-2.28c-3.51,3.33-7.36,6.31-11.22,8.59 C261.38,831.4,253.14,832.45,247.18,829.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M286.63,812.29c2.1,0.7,4.21,1.4,6.31,2.28c1.4-1.75,2.98-3.33,4.21-5.26c-2.1-1.05-4.03-1.93-5.96-2.63 C289.78,808.78,288.2,810.71,286.63,812.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.59,815.09L238.59,815.09c0.35,1.93,0.88,3.68,1.58,5.43C239.47,818.77,239.12,817.2,238.59,815.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M242.8,824.91c-0.53-0.7-1.05-1.75-1.58-2.63C241.75,823.16,242.27,824.21,242.8,824.91z"
}), React.createElement("path", {
  className: "st1",
  d: "M270.15,831.92c-0.18,0.18-0.35,0.35-0.7,0.53C269.8,832.45,270.15,831.92,270.15,831.92 C270.32,831.75,270.32,831.75,270.15,831.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M270.32,831.75c2.98-1.75,5.79-2.63,8.59-4.03c0.35-0.18,0.7-0.53,1.05-0.7 C276.81,828.59,273.48,830.34,270.32,831.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M281.72,817.37c2.1,0.53,4.56,1.23,7.01,2.28c1.58-1.58,2.98-3.33,4.56-5.08c-2.28-1.05-4.21-1.58-6.31-2.28 C284.87,814.04,283.3,815.97,281.72,817.37z"
}), React.createElement("path", {
  className: "st1",
  d: "M291.71,729.36c-0.7,0-1.58,0-2.28,0c-4.91,0.53-10.34,2.28-15.95,5.61c-4.56,2.63-8.94,6.14-12.97,10.17 c-12.27,12.27-22.44,29.8-26.82,46.46c-1.4,5.43-2.28,10.87-2.28,16.13c0,4.38,0.7,8.06,1.58,11.57c1.75-1.23,3.68-2.63,5.43-3.86 c-1.05-4.91-0.88-10.34,0.18-16.13c0-0.53,0.18-1.05,0.18-1.4c0.35-1.58,0.7-2.98,1.05-4.56c1.93-7.89,4.91-15.95,9.47-23.67 c4.38-7.71,9.82-14.2,15.43-19.64c1.4-1.4,2.63-2.63,4.03-3.86c0.18-0.18,0.35-0.35,0.53-0.35c7.01-5.96,14.55-9.64,21.56-9.64 c0.35,0,0.88-0.18,1.23-0.18c0.18,0,0.35,0.18,0.53,0.18c2.1,0.18,4.21,0.7,6.31,1.58c0.35,0.18,0.7,0,0.88,0.18c0,0,0,0,0.18,0.18 l0,0c2.63,1.4,5.79,0.35,7.71-1.93c-1.4-1.58-2.98-2.8-4.73-3.86c-2.28-1.23-4.73-1.93-7.19-2.45 C294.87,729.36,293.29,729.36,291.71,729.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M247.18,829.29c-0.18,0-0.18-0.18-0.35-0.35c-0.88-0.53-1.75-1.4-2.45-2.1c-1.75,1.05-3.51,2.45-5.26,3.68 c1.4,1.4,2.81,2.98,4.73,4.21c1.75,1.05,3.68,1.75,5.61,2.1C250.51,833.85,249.99,830.69,247.18,829.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M240.69,821.75c-0.18-0.35-0.35-0.7-0.53-1.05c-0.7-1.58-1.23-3.51-1.58-5.26c-1.93,1.23-3.68,2.63-5.43,3.86 c0.53,1.75,0.88,3.51,1.58,4.91c0.18,0.53,0.53,0.88,0.7,1.4C237.36,824.03,238.94,822.8,240.69,821.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M244.55,826.84c-0.53-0.53-1.23-1.05-1.75-1.75c-0.7-0.88-1.05-1.75-1.58-2.63c-0.18-0.35-0.35-0.53-0.53-0.88 c-1.75,1.23-3.51,2.45-5.26,3.68c0.18,0.35,0.35,0.53,0.53,0.88c0.7,1.23,1.4,2.45,2.28,3.51c0.35,0.35,0.7,0.53,1.05,0.88 C241.04,829.29,242.8,828.06,244.55,826.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M289.43,729.36c0.7,0,1.58,0,2.28,0C291.01,729.36,290.48,729.19,289.43,729.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.5,744.97c-6.31,6.14-12.1,13.32-16.66,21.21c-4.56,8.06-8.06,16.66-10.17,25.25 C238.24,774.59,248.23,757.06,260.5,744.97z"
}), React.createElement("path", {
  className: "st1",
  d: "M303.46,731.82c-2.1-1.23-4.56-1.93-7.19-2.45C298.72,729.71,300.83,730.76,303.46,731.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.94,830.52c1.4,1.58,2.98,2.98,4.91,4.03c-1.75-1.23-3.33-2.63-4.73-4.21 C239.12,830.52,239.12,830.52,238.94,830.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M234.73,823.86c0.18,0.53,0.53,0.88,0.7,1.4l0,0C235.26,824.91,235.08,824.56,234.73,823.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M235.61,825.26L235.61,825.26c0.18,0.35,0.35,0.53,0.53,0.88C235.78,825.96,235.61,825.61,235.61,825.26z"
}), React.createElement("path", {
  className: "st1",
  d: "M238.42,829.64c0.35,0.35,0.53,0.7,0.7,1.05l0.18-0.18C238.94,830.34,238.42,829.82,238.42,829.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.89,835.6C264.89,835.6,265.24,835.6,264.89,835.6c1.58-1.05,2.98-2.28,4.56-3.16 C268.04,833.5,266.47,834.73,264.89,835.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.62,832.45c-1.58,0.88-2.98,2.1-4.56,3.16c2.81-0.88,5.61-2.28,8.59-3.86c1.75-1.05,3.51-2.45,5.43-3.68 c-2.81,1.23-5.61,2.28-8.59,4.03C270.15,831.92,269.8,832.45,269.62,832.45z"
}), React.createElement("path", {
  className: "st0",
  d: "M748.06,546.86l-8.24-4.73c-28.58,23.49-49.61,61.71-53.65,98.7l18.41,10.52c0.18-0.7,0.35-1.23,0.35-1.93 c0.53-3.68,1.4-7.54,2.28-11.22c0.53-2.28,1.05-4.38,1.75-6.66c0.7-2.63,1.58-5.08,2.45-7.71c1.23-3.86,2.63-7.54,4.21-11.22 c0.53-1.23,1.05-2.28,1.58-3.51c2.28-4.91,4.56-9.64,7.36-14.38c0.18-0.18,0.18-0.53,0.35-0.7c0.18-0.17,0.35-0.35,0.35-0.7 c2.98-5.08,6.14-9.99,9.64-14.9c0.7-1.05,1.4-1.93,2.1-2.98c2.63-3.51,5.43-6.66,8.24-9.99c1.75-1.93,3.33-3.86,5.08-5.61 c1.4-1.4,2.8-2.45,4.03-3.86c2.1-2.1,4.21-4.21,6.49-5.96C756.3,550.36,751.91,549.14,748.06,546.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M703.35,661.69c0-1.05,0.35-2.1,0.35-3.16l-24.37-14.03c2.98-39.09,24.02-79.77,54.52-105.72l-5.79-3.33 c-30.68,26.82-52.07,67.85-55.22,108.52c-0.18,2.45,1.05,4.73,3.33,6.14l30.5,17.53c1.05,0.53,2.1,0.88,3.33,0.88 c-1.23,0-2.28-0.18-3.33-0.88C704.4,666.25,703.35,663.97,703.35,661.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M712.82,668C712.99,668,712.99,667.83,712.82,668c-0.88,0.35-1.93,0.7-2.98,0.7 C710.89,668.53,711.94,668.35,712.82,668z"
}), React.createElement("path", {
  className: "st1",
  d: "M813.62,528.45c7.54,0.18,14.73,1.58,21.04,5.08c-2.8-1.58-5.79-3.33-8.94-5.26 c-4.91-2.98-10.17-6.14-15.43-8.94c-1.23,1.75-2.63,3.51-4.03,5.26C808.72,525.82,810.99,527.05,813.62,528.45z"
}), React.createElement("path", {
  className: "st1",
  d: "M813.62,528.45c-2.45-1.4-4.73-2.63-7.19-4.03c-1.4,1.75-2.8,3.51-4.21,5.08 C806.09,528.8,809.77,528.27,813.62,528.45z"
}), React.createElement("path", {
  className: "st1",
  d: "M704.4,651.7l-18.41-10.52c4.03-37.17,25.07-75.21,53.65-98.7l-5.96-3.33 c-30.5,25.95-51.72,66.62-54.52,105.72l24.37,14.03c0.18-2.98,0.7-5.96,1.23-8.94C704.58,650.47,704.4,650.82,704.4,651.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M750.34,560.18c1.4-1.4,2.8-2.45,4.03-3.86C753.32,557.73,751.74,558.95,750.34,560.18z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.08,578.77c-3.51,4.73-6.66,9.64-9.64,14.9C728.42,588.41,731.75,583.67,735.08,578.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M724.39,594.89c-2.63,4.73-5.08,9.47-7.36,14.38C719.48,604.54,721.93,599.63,724.39,594.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M715.62,612.78c-1.58,3.68-2.98,7.36-4.21,11.22C712.82,620.14,714.22,616.63,715.62,612.78z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.25,566.14c-2.8,3.16-5.61,6.49-8.24,9.99C739.64,572.28,742.62,569.3,745.25,566.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M708.79,631.89c-0.7,2.28-1.23,4.38-1.75,6.66C707.73,636.27,708.08,633.99,708.79,631.89z"
}), React.createElement("path", {
  className: "st2",
  d: "M732.63,513.37c0-2.1,0.18-4.21,0.53-6.49c0.35-2.81,0.88-5.61,1.4-8.59c0.18-0.7,0.35-1.4,0.53-2.28 c2.28-8.77,5.61-17.71,10.69-26.3c4.91-8.59,10.87-15.95,17.36-22.26c0.7-0.7,1.58-1.4,2.28-2.1c1.93-1.75,3.86-3.33,5.96-4.91 c1.93-1.58,4.03-2.81,5.96-4.21c0.18,0,0.18-0.18,0.35-0.35c0.35-0.18,0.7-0.35,1.23-0.53c2.45-1.4,4.91-2.98,7.36-3.86 c-6.14-3.51-11.92-6.31-14.73-6.84c-0.88-0.18-1.75-0.18-2.63-0.18c-19.46,0-41.02,25.6-49.96,50.84 c-5.43,15.78-7.01,35.41,5.26,42.78l8.77,5.08c-0.35-2.28-0.18-4.73-0.18-7.19c0-0.7-0.18-1.23-0.18-1.93 C732.45,513.72,732.63,513.55,732.63,513.37z"
}), React.createElement("path", {
  className: "st1",
  d: "M720.88,523.72c-34.89-21.21,9.99-110.62,51.37-105.36c5.08,0.7,14.73,5.96,23.49,11.22 c6.66-0.7,12.8,0.18,18.06,3.33c0,0,0,0,0.18,0.18c0,0,0-0.18-0.18-0.18c-1.93-1.05-4.56-2.63-7.36-4.38 c-14.38-8.94-26.12-15.6-33.48-16.66c-28.05-3.68-55.22,27.52-66.27,59.26c-9.29,26.65-5.26,48.39,10.87,58.2l10.52,6.14 c1.75-1.58,3.33-3.16,5.08-4.56L720.88,523.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M741.22,541.25c-0.35,0.35-0.88,0.7-1.23,1.05l8.24,4.73C745.25,545.46,742.97,543.35,741.22,541.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.36,535.64c-0.53-1.05-1.05-2.1-1.58-3.16l-2.8-1.58c-1.75,1.4-3.33,2.98-5.08,4.56l5.79,3.33 C735.08,537.92,736.14,536.86,737.36,535.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M741.22,541.25c-1.4-1.58-2.45-3.51-3.51-5.43c-1.23,1.05-2.45,2.1-3.68,2.98l5.96,3.33 C740.34,541.95,740.52,541.42,741.22,541.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.08,496.02c-0.18,0.7-0.35,1.4-0.53,2.28C734.73,497.24,734.91,496.54,735.08,496.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M777.16,436.23c-2.1,1.23-4.03,2.63-5.96,4.21C773.3,439.04,775.41,437.29,777.16,436.23z"
}), React.createElement("path", {
  className: "st1",
  d: "M763.13,447.28c0.7-0.7,1.58-1.4,2.28-2.1C764.71,446.05,763.66,446.58,763.13,447.28z"
}), React.createElement("path", {
  className: "st1",
  d: "M732.63,513.37c0-2.1,0.35-4.21,0.53-6.49C732.8,508.99,732.63,510.92,732.63,513.37z"
}), React.createElement("path", {
  className: "st1",
  d: "M732.63,516.18c0,2.45-0.18,4.91,0.18,7.19l-8.77-5.08c-12.27-7.36-10.87-27-5.26-42.78 c8.77-25.42,30.5-50.84,49.96-50.84c0.88,0,1.75,0,2.63,0.18c2.8,0.35,8.77,3.33,14.73,6.84c-2.45,0.88-4.91,2.45-7.36,3.86 c5.79-3.16,11.4-5.08,16.83-5.79c-8.77-5.26-18.41-10.52-23.49-11.22c-41.37-5.26-86.43,84.15-51.37,105.36l12.45,7.19 c0.53-0.53,1.23-0.88,1.75-1.23C733.68,525.65,732.8,521.26,732.63,516.18z"
}), React.createElement("path", {
  className: "st1",
  d: "M732.98,531.08l2.8,1.58c-0.35-0.88-0.7-1.93-0.88-2.98C734.21,530.2,733.86,530.38,732.98,531.08z"
}), React.createElement("path", {
  className: "st0",
  d: "M828.18,544.75c-2.8-1.4-5.79-2.45-8.77-3.16c-0.7-0.18-1.58-0.18-2.45-0.35c-1.93-0.35-3.86-0.35-5.96-0.18 c-2.98,0.18-5.96,0.7-9.12,1.4c-1.4,0.35-2.63,0.53-4.03,1.05c-3.86,1.23-7.89,3.16-12.1,5.43c-0.53,0.35-1.05,0.53-1.75,0.7 c-13.68,8.24-25.95,19.99-36.47,33.48c-0.18,0.18-0.35,0.35-0.35,0.53c-1.93,2.45-3.51,5.08-5.26,7.71 c-1.75,2.63-3.51,5.26-5.26,8.06c-5.61,9.47-10.34,19.46-13.85,29.8c-0.18,0.18-0.18,0.53-0.18,0.7 c-1.75,5.08-3.16,10.34-4.21,15.6c0,0.18-0.18,0.53-0.18,0.7c-0.18,1.23-0.35,2.45-0.53,3.68l127.28-73.63 C843.6,561.59,837.64,550.19,828.18,544.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M812.92,541.07c-0.53,0-1.23,0.18-1.75,0.35c1.93,0,4.03,0,5.96,0.18 C815.38,541.25,814.15,541.07,812.92,541.07z"
}), React.createElement("path", {
  className: "st0",
  d: "M742.1,591.56c1.75-2.63,3.33-5.26,5.26-7.71C745.6,586.13,743.85,588.93,742.1,591.56z"
}), React.createElement("path", {
  className: "st0",
  d: "M797.85,543.7c1.4-0.53,2.63-0.7,4.03-1.05C800.65,543.18,799.42,543.35,797.85,543.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M717.55,649.94l0.35-0.18c0.18-1.23,0.35-2.45,0.53-3.68C718.43,647.49,717.73,648.72,717.55,649.94z"
}), React.createElement("path", {
  className: "st0",
  d: "M828.18,544.75c-2.63-1.58-5.61-2.45-8.77-3.16C822.39,542.3,825.2,543.35,828.18,544.75L828.18,544.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M736.14,600.68c-5.43,9.29-9.64,18.93-12.97,28.4c3.51-10.34,8.24-20.34,13.85-29.8 C736.84,599.98,736.31,600.33,736.14,600.68z"
}), React.createElement("path", {
  className: "st0",
  d: "M784.35,550.01c0.53-0.35,1.05-0.53,1.75-0.7C785.4,549.31,784.7,549.66,784.35,550.01 c-13.15,7.54-25.6,19.11-36.47,33.48C758.05,569.65,770.5,558.08,784.35,550.01z"
}), React.createElement("path", {
  className: "st0",
  d: "M718.6,645.56c1.05-5.26,2.45-10.52,4.21-15.6C721.06,635.39,719.66,640.48,718.6,645.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M834.66,533.53c2.98,1.75,4.21,5.61,2.45,8.77c-0.18,0.35-0.7,0.35-0.88,0.7c8.94,7.71,14.9,19.99,15.95,36.82 l-135.34,78.19c-0.18,1.58-0.53,2.98-0.7,4.56c-0.18,2.28-1.4,4.21-3.33,5.26c0,0,0,0,0.18,0l142.36-82.22 c2.1-1.23,3.33-3.51,3.16-5.96C857.45,558.08,848.86,541.95,834.66,533.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.25,566.14c1.75-1.93,3.33-3.86,5.08-5.61C748.58,562.11,747.18,564.21,745.25,566.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M754.72,556.5c2.1-2.1,4.38-4.03,6.66-5.96h-0.18C758.93,552.29,756.82,554.4,754.72,556.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M711.24,624c-0.88,2.63-1.75,5.08-2.45,7.71C709.66,629.08,710.54,626.63,711.24,624z"
}), React.createElement("path", {
  className: "st1",
  d: "M707.03,638.55c-0.88,3.86-1.75,7.54-2.28,11.22C705.46,646.09,706.33,642.05,707.03,638.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.19,575.96c-0.7,0.88-1.4,1.93-2.1,2.98C735.78,577.71,736.31,577.01,737.19,575.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M717.38,609.27c-0.53,1.23-1.05,2.28-1.58,3.51C716.33,611.55,716.68,610.32,717.38,609.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M724.39,594.89c0.35-0.53,0.53-0.88,0.88-1.4c-0.18,0.18-0.35,0.35-0.35,0.7 C724.92,594.54,724.56,594.89,724.39,594.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M831.51,539.14c-2.98-1.58-5.79-2.45-8.77-3.33C825.72,536.86,828.88,537.74,831.51,539.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M718.6,623.47c-0.53,1.4-1.23,2.98-1.75,4.38C717.38,626.63,717.73,625.22,718.6,623.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M808.01,534.76c-3.68,0.35-7.54,1.23-11.22,2.45C800.65,535.99,804.16,535.29,808.01,534.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M740.69,581.75c-3.68,5.08-7.19,10.34-10.34,15.78C733.86,591.91,737.19,586.83,740.69,581.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M748.23,572.98c-2.28,2.63-4.56,5.08-6.66,7.89C743.67,578.06,745.95,575.43,748.23,572.98z"
}), React.createElement("path", {
  className: "st1",
  d: "M809.59,534.59c3.51-0.18,6.84,0,9.99,0.53C816.08,534.59,812.92,534.59,809.59,534.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M789.78,540.02c1.4-0.53,2.8-1.4,4.21-1.93c-1.23,0.35-2.28,0.88-3.51,1.4 C790.13,539.85,789.96,540.02,789.78,540.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.35,598.05c-2.8,4.73-5.26,9.64-7.54,14.73C725.09,607.69,727.54,602.61,730.35,598.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M831.51,539.14c1.75,1.05,3.16,2.45,4.73,3.86c0.18-0.35,0.7-0.35,0.88-0.7c1.58-3.16,0.53-7.01-2.45-8.77 c-6.31-3.68-13.5-5.08-21.04-5.08C819.76,532.31,826.07,536.34,831.51,539.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M716.33,662.57c0.18-1.58,0.53-2.98,0.7-4.56l-7.01,4.03l-6.14-3.51c0,1.05-0.35,2.1-0.35,3.16 c0,2.45,1.05,4.56,3.16,5.96c1.05,0.7,2.28,0.88,3.33,0.88c1.05,0,2.1-0.35,3.16-0.88C714.92,666.77,716.15,664.85,716.33,662.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M718.6,623.47c1.4-3.68,2.63-7.36,4.38-11.04c2.28-5.08,4.73-9.82,7.54-14.73c0-0.18,0.18-0.18,0.18-0.35l0,0 c3.16-5.43,6.49-10.69,10.34-15.78c0.18-0.35,0.35-0.7,0.7-1.05c2.1-2.8,4.38-5.26,6.66-7.89c8.59-10.17,18.06-18.76,28.05-25.25 c-4.73,1.75-9.47,2.98-13.85,2.98c-0.35,0-0.53-0.18-0.88-0.18c-2.28,1.93-4.56,3.86-6.66,5.96c-1.4,1.23-2.8,2.45-4.03,3.86 c-1.75,1.75-3.33,3.68-5.08,5.61c-2.8,3.16-5.61,6.49-8.24,9.99c-0.7,0.88-1.4,1.93-2.1,2.98c-3.33,4.73-6.66,9.64-9.64,14.9 c-0.35,0.53-0.53,0.88-0.88,1.4c-2.63,4.73-5.08,9.47-7.36,14.38c-0.53,1.23-1.05,2.28-1.58,3.51c-1.58,3.68-2.98,7.36-4.21,11.22 c-0.88,2.63-1.75,5.08-2.45,7.71c-0.7,2.28-1.23,4.38-1.75,6.66c-0.88,3.68-1.75,7.54-2.28,11.22c-0.53,2.98-0.88,5.96-1.23,8.94 l6.14,3.51c0.7-11.04,3.16-22.62,7.01-34.01C717.38,626.63,717.73,625.22,718.6,623.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M801.88,529.5c-3.51,3.86-7.54,7.01-11.57,9.99c1.23-0.53,2.28-1.05,3.51-1.4c0.88-0.35,1.75-0.53,2.63-0.88 c3.68-1.23,7.36-2.1,11.22-2.45c0.53,0,1.05-0.18,1.58-0.18c3.33-0.18,6.66-0.18,9.99,0.53c1.05,0.18,2.1,0.53,3.16,0.7 c2.98,0.7,5.79,1.75,8.77,3.33c-5.26-2.98-11.4-7.01-17.88-10.69C809.77,528.27,806.09,528.8,801.88,529.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M718.6,646.26c0-0.18,0.18-0.53,0.18-0.7C718.6,645.74,718.6,646.09,718.6,646.26z"
}), React.createElement("path", {
  className: "st1",
  d: "M828.35,545.11c0,0-0.18,0-0.35-0.18c9.47,5.43,15.43,16.48,17.18,31.38L717.9,649.94 c-0.53,2.8-0.88,5.43-1.23,8.06l135.34-78.19c-1.05-16.83-7.01-29.28-15.95-36.82C834.31,545.46,831.16,546.51,828.35,545.11z"
}), React.createElement("path", {
  className: "st1",
  d: "M816.96,541.42c0.88,0.18,1.58,0.18,2.45,0.35C818.53,541.42,817.66,541.42,816.96,541.42z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.01,599.28c1.58-2.8,3.51-5.43,5.26-8.06C740.52,594.02,738.41,596.82,737.01,599.28z"
}), React.createElement("path", {
  className: "st1",
  d: "M722.99,629.96c0-0.18,0.18-0.53,0.18-0.7C722.99,629.61,722.99,629.78,722.99,629.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M747.36,583.85c0.18-0.18,0.35-0.35,0.35-0.53C747.53,583.5,747.36,583.67,747.36,583.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M801.88,542.65c3.16-0.7,6.14-1.4,9.12-1.4C808.19,541.25,805.21,541.95,801.88,542.65z"
}), React.createElement("path", {
  className: "st1",
  d: "M785.75,548.96c4.21-2.28,8.24-4.03,12.1-5.43C794.17,545.11,790.13,546.68,785.75,548.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M822.74,535.81c-1.05-0.35-2.1-0.53-3.16-0.7c-3.16-0.53-6.49-0.7-9.99-0.53c-0.53,0-1.05,0-1.58,0.18 c-3.51,0.35-7.36,1.23-11.22,2.45c-0.88,0.35-1.75,0.53-2.63,0.88c-1.4,0.53-2.8,1.4-4.21,1.93c-1.93,1.4-3.68,2.8-5.61,3.86 c-2.63,1.4-5.08,2.28-7.54,3.33c-10.52,7.01-19.99,15.6-28.4,25.42c-2.28,2.63-4.56,5.08-6.66,7.89c-0.18,0.35-0.35,0.7-0.7,1.05 c-3.68,4.91-7.01,10.17-10.34,15.78c0,0.18-0.18,0.35-0.18,0.35c-2.8,4.73-5.26,9.64-7.54,14.73c-1.58,3.68-2.98,7.36-4.38,11.04 c-0.53,1.4-1.23,2.98-1.75,4.38c-3.68,11.22-6.14,22.79-7.01,34.01l7.01-4.03c0.35-2.63,0.7-5.43,1.23-8.06l-0.35,0.18 c0.18-1.23,0.53-2.63,0.88-3.86c0-0.18,0.18-0.53,0.18-0.7c1.05-5.08,2.45-10.34,4.21-15.6c0-0.18,0.18-0.53,0.18-0.7 c3.33-9.64,7.54-19.11,12.97-28.4c0.35-0.53,0.53-0.88,0.88-1.4c1.58-2.8,3.51-5.26,5.26-8.06c1.75-2.63,3.33-5.26,5.26-7.71 c0.18-0.18,0.35-0.35,0.35-0.53c10.87-14.2,23.32-25.95,36.29-33.48c0.53-0.35,1.23-0.53,1.75-0.7c4.21-2.28,8.24-4.03,12.1-5.43 c1.4-0.53,2.63-0.7,4.03-1.05c3.16-0.88,6.14-1.4,9.12-1.4c0.53,0,1.23-0.35,1.75-0.35c1.4,0,2.8,0.35,4.21,0.53 c0.88,0.18,1.58,0.18,2.45,0.35c3.16,0.7,6.14,1.58,8.77,3.16l0,0c0,0,0.18,0,0.35,0.18c2.63,1.4,5.79,0.35,7.71-1.93 c-1.58-1.4-2.98-2.8-4.73-3.86C828.88,537.74,825.72,536.86,822.74,535.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.35,598.05c0-0.18,0.18-0.35,0.18-0.35l0,0C730.53,597.7,730.53,597.88,730.35,598.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M741.57,580.69c-0.18,0.35-0.35,0.7-0.7,1.05C740.87,581.57,741.4,581.04,741.57,580.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M748.23,572.98c8.41-9.82,18.06-18.58,28.4-25.42c-0.18,0-0.35,0.18-0.53,0.18 C766.11,554.22,756.82,562.81,748.23,572.98z"
}), React.createElement("path", {
  className: "st1",
  d: "M822.74,535.81c-1.05-0.35-2.1-0.53-3.16-0.7C820.46,535.46,821.69,535.64,822.74,535.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M709.84,662.04c0.88-11.4,3.33-22.79,7.01-34.01C712.99,639.6,710.54,651,709.84,662.04z"
}), React.createElement("path", {
  className: "st1",
  d: "M796.62,537.22c-0.88,0.35-1.75,0.53-2.63,0.88C795.04,537.92,795.74,537.74,796.62,537.22z"
}), React.createElement("path", {
  className: "st1",
  d: "M808.01,534.76c0.53,0,1.05-0.18,1.58-0.18C808.89,534.76,808.54,534.76,808.01,534.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M722.81,612.43c-1.58,3.68-2.98,7.36-4.38,11.04C719.66,619.97,721.06,616.11,722.81,612.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M816.08,441.67c-0.18,0.35-0.7,0.35-0.88,0.7c4.73,5.08,7.54,12.97,7.54,23.32c0,16.66-7.19,35.41-18.23,50.49 c1.93,0.88,3.86,1.93,5.79,2.98c11.57-15.95,18.93-35.76,18.93-53.47c0-15.25-5.43-26.82-15.43-32.61 C816.96,435.01,818.01,438.51,816.08,441.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M757,543.53c-0.18,0.35,0,0.88-0.18,1.23c-1.23,2.1-3.33,3.16-5.61,3.16c-1.05,0-2.28-0.35-3.16-0.88 c4.03,2.28,8.41,3.33,13.15,3.51c3.68-2.98,7.36-5.61,11.22-8.24C766.82,544.4,761.38,544.58,757,543.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M791.36,532.48c1.58-0.53,3.16-1.05,4.56-1.4c1.93-0.53,3.51-1.4,5.43-1.75c-1.93-1.05-3.86-1.75-5.79-2.63 c-2.63,2.63-5.43,5.08-8.24,7.36C788.73,533.36,789.96,532.83,791.36,532.48z"
}), React.createElement("path", {
  className: "st1",
  d: "M800.48,521.44c1.93,0.88,4.03,1.93,5.96,2.98c1.4-1.75,2.8-3.33,4.03-5.26c-1.93-1.05-3.86-2.1-5.79-2.98 C803.11,518.11,801.88,519.68,800.48,521.44z"
}), React.createElement("path", {
  className: "st1",
  d: "M786.28,534.59c1.75-0.7,3.51-1.75,5.08-2.45c-1.23,0.53-2.63,0.88-3.86,1.4 C786.98,534.24,786.63,534.59,786.28,534.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M795.74,526.7c1.93,0.88,3.68,1.58,5.79,2.63c-1.93,0.35-3.68,1.23-5.43,1.75c2.1-0.53,4.03-0.88,5.96-1.23 c1.58-1.58,2.8-3.33,4.21-5.08c-1.93-1.05-4.03-2.1-5.96-2.98C798.72,523.37,797.5,524.77,795.74,526.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M734.38,498.12c-0.7,2.98-1.23,5.79-1.4,8.59C733.33,503.73,733.86,500.93,734.38,498.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.78,469.72c-4.91,8.59-8.41,17.53-10.69,26.3C737.36,487.08,741.22,477.96,745.78,469.72 c4.91-7.89,10.87-15.6,17.36-22.26C756.65,453.77,750.51,460.95,745.78,469.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M732.45,514.07c0,0.7,0.18,1.23,0.18,1.93c0-1.05-0.18-1.93-0.18-2.98 C732.63,513.55,732.45,513.72,732.45,514.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M771.2,440.27c-1.93,1.4-4.03,3.16-5.96,4.91C767.17,443.42,769.27,441.84,771.2,440.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M777.16,436.23c0.53-0.35,1.05-0.53,1.58-0.88c-0.35,0.18-0.7,0.35-1.23,0.53 C777.69,435.88,777.51,436.23,777.16,436.23z"
}), React.createElement("path", {
  className: "st1",
  d: "M795.57,429.75c5.79,3.33,11.22,6.84,14.9,8.94c1.75,1.05,3.33,2.28,4.73,3.86c0.35-0.35,0.7-0.35,0.88-0.7 c1.75-2.98,0.53-6.84-2.28-8.59c0,0,0,0-0.18-0.18C808.54,429.75,802.23,429.05,795.57,429.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M738.76,514.07c0-5.61,1.05-11.57,2.45-17.53c-2.98,10.52-3.68,20.69-1.23,29.1l0.18-0.18 C739.47,522.31,738.76,518.46,738.76,514.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M798.72,435.88c1.58,0,3.33,0,4.73,0.18C801.88,435.88,800.48,435.88,798.72,435.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M796.79,435.88c-10.17,0.7-20.34,6.84-29.63,16.13c4.21-4.21,8.77-7.89,13.5-10.69 C786.63,438.34,792.06,436.41,796.79,435.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M748.06,546.86c1.05,0.53,2.1,0.88,3.16,0.88c2.28,0,4.38-1.05,5.61-3.16c0.18-0.35,0-0.7,0.18-1.23 c-2.1-0.53-4.03-1.05-5.79-2.1l-5.79-3.33c-1.4,1.05-2.98,1.93-4.38,3.16C742.97,543.35,745.25,545.46,748.06,546.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.96,532.48c0.53,1.05,1.05,2.1,1.58,3.16c0.53-0.53,1.23-0.88,1.75-1.23L735.96,532.48z"
}), React.createElement("path", {
  className: "st1",
  d: "M740.34,525.82c0.53,1.75,1.05,3.33,1.93,4.91c-0.7-1.58-1.23-3.33-1.58-5.08 C740.52,525.82,740.52,525.82,740.34,525.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.78,536.52c-1.05-1.23-1.93-2.63-2.63-4.21C743.85,533.71,744.55,535.29,745.78,536.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.25,537.92l-6.14-3.51c-0.53,0.53-1.23,0.88-1.75,1.23c1.05,1.93,2.1,3.86,3.51,5.43 C742.62,540.02,743.85,538.97,745.25,537.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M777.16,436.23c-2.1,1.23-4.03,2.63-5.96,4.21c-1.93,1.58-4.03,2.98-5.96,4.91c-0.7,0.7-1.58,1.4-2.28,2.1 c-6.49,6.49-12.45,14.2-17.18,22.44c-4.73,8.24-8.41,17.18-10.87,26.12c-0.18,0.7-0.35,1.4-0.53,2.28c-0.7,2.98-1.05,5.79-1.4,8.59 c-0.18,2.1-0.53,4.38-0.53,6.49c0,1.05,0,1.93,0.18,2.98c0.18,4.91,1.05,9.47,2.45,13.5c1.75-1.4,3.51-2.45,5.26-3.68 c-2.45-8.41-1.75-18.58,1.23-29.1c2.1-8.06,5.43-16.3,9.82-23.84c4.56-7.71,9.99-14.73,16.13-20.69 c9.12-9.29,19.46-15.43,29.63-16.13c0.7,0,1.23,0,1.75,0c1.58,0,3.16,0,4.73,0.18c2.45,0.35,4.91,1.23,7.01,2.28 c-3.68-2.1-9.12-5.43-14.9-8.94c-5.43,0.7-11.04,2.63-16.83,5.79C778.21,435.71,777.86,435.88,777.16,436.23z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.3,537.57c-0.35,0.18-0.7,0.35-0.88,0.7l5.79,3.33C749.28,540.37,747.88,538.97,746.3,537.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M742.8,532.13c-0.18-0.35-0.53-0.7-0.7-1.05c-0.7-1.58-1.4-3.33-1.93-4.91c-1.75,1.23-3.51,2.45-5.26,3.68 c0.35,1.05,0.53,1.93,0.88,2.98l3.33,1.93C740.52,533.53,741.57,532.83,742.8,532.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.78,536.52c-1.05-1.23-1.93-2.8-2.63-4.21l-0.18-0.18c-1.23,0.88-2.28,1.58-3.51,2.45l6.14,3.51 c0.35-0.18,0.7-0.53,0.88-0.7C745.95,537.04,745.95,536.86,745.78,536.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M796.09,530.9c-1.58,0.53-3.16,0.88-4.56,1.4C792.94,531.61,794.34,531.26,796.09,530.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M772.25,542.3c-3.86,2.45-7.54,5.08-11.22,8.24h0.18C764.71,547.74,768.74,544.75,772.25,542.3L772.25,542.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.24,543.7c2.63-1.4,5.08-2.45,7.71-3.51c0.18-0.18,0.53-0.35,0.7-0.53 C787.68,540.9,784.7,542.3,782.24,543.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.24,543.7c2.8-1.58,5.61-2.8,8.41-4.03c4.03-2.98,7.89-6.31,11.57-9.99c-1.93,0.35-4.03,0.7-5.96,1.23 c-1.58,0.53-3.16,0.88-4.56,1.4c-1.75,0.7-3.51,1.58-5.08,2.45c-1.75,1.23-3.51,2.63-5.43,3.68c-2.98,1.75-5.79,2.98-8.59,3.86 c-3.86,2.63-7.54,5.26-11.04,8.24c0.35,0,0.53,0.18,0.88,0.18c4.38,0,9.12-1.23,13.85-2.98c1.58-1.05,3.16-2.45,4.91-3.33 C781.19,544.05,781.72,544.05,782.24,543.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M781.02,544.4c-1.58,0.88-2.98,2.1-4.38,3.16c2.45-1.05,5.08-1.93,7.54-3.33c1.93-1.05,3.68-2.63,5.61-3.86 c-2.63,1.05-5.08,2.1-7.71,3.51C781.72,544.05,781.19,544.23,781.02,544.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.24,543.7c-0.35,0.18-0.7,0.35-1.05,0.53c-1.58,0.88-3.16,2.28-4.91,3.33c0.18,0,0.35-0.18,0.53-0.18 c1.4-1.05,2.8-2.1,4.38-3.16C781.19,544.23,781.72,544.05,782.24,543.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M799.95,442.37c2.45,0,4.73,0.7,6.66,1.58C804.51,442.9,802.23,442.37,799.95,442.37z"
}), React.createElement("path", {
  className: "st1",
  d: "M807.49,444.12L807.49,444.12c5.61,3.33,8.77,11.04,8.77,21.56c0,15.78-7.19,33.66-17.88,47.86 c1.93,0.7,4.03,1.75,5.96,2.63c11.04-15.08,18.23-34.01,18.23-50.49c0-10.34-2.8-18.23-7.54-23.32 C813.27,444.65,810.29,445.7,807.49,444.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M772.43,456.04c1.23-1.05,2.28-2.28,3.51-3.33C774.88,453.77,773.65,454.82,772.43,456.04z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.3,504.26c0.18-1.4,0.7-2.81,0.88-4.21C747.01,501.45,746.65,502.68,746.3,504.26z"
}), React.createElement("path", {
  className: "st1",
  d: "M798.55,442.37c-7.01,0.18-14.38,3.68-21.56,9.64c2.28-1.93,4.73-3.51,7.01-4.91 C789.43,444.12,794.17,442.72,798.55,442.37z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.25,514.07c0-2.63,0.35-5.43,0.7-8.24c-0.88,5.79-1.05,11.04,0,15.78l0,0 C745.78,519.51,745.25,517.06,745.25,514.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M754.72,535.81L754.72,535.81c2.63,1.75,3.33,4.91,2.28,7.71c4.56,1.05,9.82,0.7,15.43-1.23 c0.7-0.35,1.23-0.88,1.93-1.4c1.05-0.7,2.1-1.58,3.33-2.28c0,0,0.18,0,0.18-0.18c2.98-1.75,6.31-3.33,9.82-4.73 c2.8-2.1,5.61-4.56,8.24-7.36c-2.45-1.05-4.73-1.75-7.01-2.28c-3.51,3.33-7.36,6.31-11.22,8.59 C768.74,537.92,760.33,538.97,754.72,535.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.95,521.79L745.95,521.79c0.35,1.93,0.88,3.68,1.58,5.26C747.01,525.65,746.3,523.72,745.95,521.79z"
}), React.createElement("path", {
  className: "st1",
  d: "M794.17,519.16c2.1,0.7,4.21,1.4,6.31,2.28c1.4-1.75,2.98-3.33,4.21-5.08c-2.1-1.05-4.03-1.93-5.96-2.63 C797.15,515.65,795.57,517.23,794.17,519.16z"
}), React.createElement("path", {
  className: "st1",
  d: "M777.86,538.62L777.86,538.62c-1.23,0.88-2.28,1.75-3.51,2.45C775.58,540.2,776.63,539.32,777.86,538.62 c2.8-1.58,5.61-2.63,8.41-3.86c0.35-0.35,0.88-0.53,1.23-0.88C784.17,535.46,780.84,536.86,777.86,538.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M788.73,524.42c2.1,0.53,4.38,1.23,7.01,2.28c1.58-1.58,2.98-3.33,4.56-5.08c-2.28-1.05-4.21-1.58-6.31-2.28 C792.24,521.09,790.66,522.49,788.73,524.42z"
}), React.createElement("path", {
  className: "st1",
  d: "M750.16,531.61c-0.53-0.7-0.88-1.4-1.23-2.1C749.28,530.2,749.46,531.08,750.16,531.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M798.72,435.88c-0.53,0-1.23,0-1.75,0c-4.91,0.53-10.34,2.28-15.95,5.43c-4.73,2.81-9.29,6.49-13.5,10.69 c-11.75,11.92-21.39,28.58-25.95,44.71c-1.58,5.96-2.45,11.75-2.45,17.53c0,4.38,0.7,8.06,1.58,11.57 c1.75-1.23,3.68-2.63,5.43-3.86c-0.88-4.73-0.88-10.17,0-15.78c0.18-0.7,0.18-1.23,0.35-1.93c0.35-1.4,0.53-2.81,0.88-4.21 c1.93-7.89,4.91-15.95,9.47-23.84c4.38-7.71,9.82-14.38,15.78-19.99c1.23-1.23,2.45-2.28,3.51-3.33c0.35-0.18,0.7-0.53,0.88-0.7 c7.01-5.96,14.38-9.47,21.56-9.64c0.35,0,0.7-0.18,1.05-0.18c0.18,0,0.35,0.18,0.53,0.18c2.28,0.18,4.56,0.7,6.66,1.58 c0.18,0.18,0.53,0,0.7,0.18l0,0h0.18c2.63,1.4,5.79,0.53,7.71-1.75c-1.4-1.58-2.98-2.81-4.73-3.86c-2.28-1.23-4.73-1.93-7.01-2.28 C801.88,435.88,800.48,435.88,798.72,435.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M754.72,535.81L754.72,535.81C754.54,535.81,754.54,535.81,754.72,535.81c-1.23-0.7-1.93-1.58-2.8-2.45 c-1.75,1.23-3.51,2.45-5.26,3.68c1.4,1.58,2.8,2.98,4.73,4.21c1.75,1.05,3.68,1.75,5.79,2.1 C758.05,540.9,757.17,537.74,754.72,535.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M748.23,528.27c-0.18-0.35-0.35-0.7-0.53-1.23c-0.7-1.58-1.23-3.33-1.58-5.26c-1.93,1.23-3.68,2.63-5.43,3.86 c0.53,1.75,0.88,3.68,1.58,5.08c0.18,0.35,0.53,0.7,0.7,1.05C744.73,530.9,746.13,529.33,748.23,528.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M751.74,533.53c-0.53-0.53-1.23-1.05-1.75-1.75c-0.53-0.7-0.88-1.4-1.23-2.1c-0.18-0.53-0.53-0.88-0.7-1.23 c-1.75,1.23-3.51,2.45-5.26,3.68l0.18,0.18c0.88,1.58,1.75,2.98,2.63,4.21c0.18,0.35,0.7,0.53,0.88,0.7 C748.23,535.99,750.16,534.59,751.74,533.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M796.79,435.88c0.53,0,1.23,0,1.75,0C798.2,435.88,797.5,435.88,796.79,435.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.52,452.19c-6.14,5.96-11.75,12.97-16.13,20.69c-4.38,7.54-7.71,15.78-9.82,23.84 C745.95,480.59,755.77,464.11,767.52,452.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M810.64,438.51c-2.1-1.23-4.56-1.93-7.01-2.28C805.91,436.76,808.37,437.29,810.64,438.51z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.3,537.57c1.4,1.58,2.98,2.98,4.91,4.03c-1.93-1.23-3.33-2.63-4.73-4.21 C746.3,537.22,746.3,537.22,746.3,537.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M742.1,531.08c0.18,0.35,0.53,0.7,0.7,1.05l0,0C742.62,531.61,742.45,531.26,742.1,531.08z"
}), React.createElement("path", {
  className: "st1",
  d: "M742.8,532.13L742.8,532.13L742.8,532.13C742.8,532.31,742.8,532.31,742.8,532.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.78,536.52c0.18,0.35,0.53,0.7,0.7,0.88c0,0,0.18,0,0.18-0.18C746.13,536.86,745.95,536.86,745.78,536.52z "
}), React.createElement("path", {
  className: "st1",
  d: "M772.25,542.3L772.25,542.3c0.7-0.53,1.23-0.88,1.93-1.4C773.48,541.42,773.13,541.95,772.25,542.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M774.35,541.07c-0.7,0.35-1.23,0.88-1.93,1.4c2.8-0.88,5.61-2.28,8.59-3.86c1.93-1.05,3.68-2.45,5.43-3.68 c-2.8,1.23-5.61,2.28-8.59,4.03C776.63,539.32,775.58,540.2,774.35,541.07z"
}));

var SvgTeambuildingIcon = function SvgTeambuildingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTeambuildingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Teambuilding_Icon.05ccd8e4.svg";
export { ForwardRef as ReactComponent };